import React from 'react';
import '../template-file-css/document-file-template.css';


export const BFCS_YouthAssessment1915 = ({
    itemsRef,
    showErrorFor,
}) => {

    return (
        <form id='BFCS_YouthAssessment1915' className='file-pdf-document'>
            <div className='file-template'>


                <h2>Demographic Information</h2>
                <table>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>Child/Youth Name:</span>
                            <span className='small'>(first, middle, last)</span>
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Child/Youth Address:</span>
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Age: </span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='text' id="txtYouthName" name="txtYouthName" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type='text' id="txtClientAddress" name="txtClientAddress" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type='text' id="txtAge" name="txtAge" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>DOB:</span>
                        </td>
                        <td className='w-200'>
                            <span className='eleHeader'>Ethnicity:  </span>
                        </td>
                        <td className='w-150'>
                            <span className='eleHeader'>Gender:</span>
                        </td>
                        <td className='w-150'>
                            <span className='eleHeader'>SSN:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='date' id="txtDob" name="txtDob" className="add-only" />
                        </td>
                        <td className='w-200'>
                            <input type='text' id="txtEthnicity" name="txtEthnicity" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="radio" id="rbGender_Male" name="rbGender" className='add-only' value="Male" /> Male &nbsp;
                            <input type="radio" id="rbGender_Female" name="rbGender" className='add-only' value="Female" /> Female
                        </td>
                        <td className='w-150'>
                            <input type='text' id="txtSsn" name="txtSsn" className='add-only' />
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Gender Expression</span>
                            <input type="text" id="txtGenderExpression" name="txtGenderExpression" className='add-only' />
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Parent/Primary Caretaker Name</span>
                            <span className='small'>(first, middle, last)</span>
                            <input type="text" id="txtCareTaker" name="txtCareTaker" className='add-only' />
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>Is this person, the legal guardian?</span>
                </p>
                <table>
                    <tr>
                        <td className='w-750'>
                            <input type="radio" id="rbLegalGuardian_Yes" name="rbLegalGuardian" className='add-only' value="Yes" /> Yes &nbsp;
                            <input type="radio" id="rbLegalGuardian_No" name="rbLegalGuardian" className='add-only' value="No" /> No &nbsp;
                            <span className='small'>(if not, enter information below)</span>
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>Legal Guardian Name</span>
                            <span className='small'>(first, middle, last)</span>
                            <input type="text" id="txtLegalName" name="txtLegalName" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Title/Department</span>
                            <input type="text" id="txtTitle" name="txtTitle" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Phone Number</span>
                            <input type="text" id="txtPhoneNumber" name="txtPhoneNumber" className='add-only' />
                        </td>
                    </tr>
                </table>
                <h2>BEHAVIORAL HEALTH HISTORY</h2>
                <p className='w-750'>
                    <span className='eleHeader'>I. CHIEF COMPLAINT</span>
                    <span className='small'>(Major symptoms, difficulties, and/or Issues as they relate to behavioral health -in client/members'/caretaker's own words/quoted.)</span>
                    <textarea id="txtChiefComplaint" name="txtChiefComplaint" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>II. PRESENTING PROBLEM/RELEVANT HISTORY</span>
                    <span className='small'>(Including client/member/caretaker/guardian reason for seeking services, precipitating factors, symptoms, behavioral and functioning impacts, onset/course of issues, current behavioral health providers, services sought and expectations.)</span>
                    <textarea id="txtRelevantHistory" name="txtRelevantHistory" className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>CURRENT BEHAVIORAL HEALTH PROVIDER NAME: </span>
                            <input type="text" id="txtCurrentBehavioralHealthProviderName" name="txtCurrentBehavioralHealthProviderName" className='add-only' />
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>PHONE NUMBER:</span>
                            <input type="text" id="txtRelPhoneNumber" name="txtRelPhoneNumber" className='add-only' />
                        </td>
                    </tr>
                </table>
                <h2>III. PAST PSYCHIATRIC/PLACEMENT HISTORY
                    <span className='small'>(First onset of illness, past diagnostic and treatment history, medications, hospitalizations):</span>
                </h2>
                <p className='w-750'>
                    <span className='eleHeader'>Prior Outpatient Mental Health Treatment:</span>
                </p>
                <table>
                    <tr>
                        <td className='w-750'>
                            <input type="radio" id="rbMentalHealthTreatment_No" name="rbMentalHealthTreatment" className='add-only' value="No" /> No &nbsp;
                            <input type="radio" id="rbMentalHealthTreatment_Yes" name="rbMentalHealthTreatment" className='add-only' value="Yes" /> Yes &nbsp;
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span><b>Detail:</b></span>
                    <br />
                    <textarea id="txtDetail_1" name="txtDetail_1" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Psychiatric Hospitalizations:</span>
                </p>
                <table>
                    <tr>
                        <td className='w-750'>
                            <input type="radio" id="rbPsychiatricHospitalizations_No" name="rbPsychiatricHospitalizations" className='add-only' value="No" /> No &nbsp;
                            <input type="radio" id="rbPsychiatricHospitalizations_Yes" name="rbPsychiatricHospitalizations" className='add-only' value="Yes" /> Yes &nbsp;
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span><b>Detail:</b></span><br />
                    <textarea id="txtDetail_2" name="txtDetail_2" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Prior Residential/Out of Home Placement</span>
                </p>
                <table>
                    <tr>
                        <td className='w-750'>
                            <input type="radio" id="rbOutOfHomePlacement_No" name="rbOutOfHomePlacement" className='add-only' value="No" /> No &nbsp;
                            <input type="radio" id="rbOutOfHomePlacement_Yes" name="rbOutOfHomePlacement" className='add-only' value="Yes" /> Yes &nbsp;
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span><b>Detail:</b></span><br />
                    <textarea id="txtDetail_3" name="txtDetail_3" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Additional History/Comments:</span>
                    <textarea id="txtAdditionalHistoryComments" name="txtAdditionalHistoryComments" className='add-only'></textarea>
                </p>
                <h2>IV. SUBSTANCE USE HISTORY
                    <span className='small'>(Past use of primary, secondary & tertiary current substance, incl. type, freq, method & age of 1st use.)</span>
                </h2>
                <p className='w-750'>
                    <span className='eleHeader'>Check any/all that apply in past 12 months</span>
                </p>
                <table>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbSA_1" name="cbSA_1" className='add-only' value="Alcohol Use" />
                            Alcohol Use;
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbSA_2" name="cbSA_2" className='add-only' value="Illegal Drug Use" />
                            Illegal Drug Use;
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbSA_3" name="cbSA_3" className='add-only' value="Injected Drug Use" />
                            Injected Drug Use;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbSA_4" name="cbSA_4" className='add-only' value="Tobacco Product Use" />
                            Tobacco Product Use;
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbSA_5" name="cbSA_5" className='add-only' value="Prescription Drugs Abuse" />
                            Prescription Drugs Misuse;
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbSA_11" name="cbSA_11" className='add-only' value="Caffeine Use" />
                            Caffeine Use;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbSA_7" name="cbSA_7" className='add-only' value="Alcohol and/or Drug Overdose" />
                            Alcohol and/or Drug Overdose;
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbSA_8" name="cbSA_8" className='add-only' value="Alcohol and/or Drug Withdrawal" />
                            Alcohol and/or Drug Withdrawal;
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbSA_9" name="cbSA_9" className='add-only' value="Problems Cause by Gambling" />
                            Problems Caused by Gambling;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbSA_10" name="cbSA_10" className='add-only' value="Trouble Stopping Any Substance" />
                            Trouble Stopping Any Substance;
                        </td>
                        <td className='w-500'>
                            <input type="checkbox" id="cbSA_6" name="cbSA_6" className='add-only' value="Non-Prescription (OTC) abuse" />
                            Non-Prescription Drug (OTC) Misuse;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="checkbox" id="cbOtherDescribe" name="cbOtherDescribe" className='add-only' value="Other/Describe" />
                            Other/Describe:
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <textarea id="txtOtherDescribe" name="txtOtherDescribe" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Substance Use Treatment History:</span>
                </p>
                <table>
                    <tr>
                        <td className='w-187'>
                            <input type="checkbox" id="cbNone" name="cbNone" className='add-only' value="None" />
                            None;
                        </td>
                        <td className='w-187'>
                            <input type="checkbox" id="cbOutpatient" name="cbOutpatient" className='add-only' value="Outpatient" />
                            Outpatient;
                        </td>
                        <td className='w-187'>
                            <input type="checkbox" id="cbIntensiveOutpatient" name="cbIntensiveOutpatient" className='add-only' value=" Intensive Outpatient" />
                            Intensive Outpatient;
                        </td>
                        <td className='w-187'>
                            <input type="checkbox" id="cbResidentialInpatient" name="cbResidentialInpatient" className='add-only' value=" Residential/Inpatient" />
                            Residential/Inpatient;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type="checkbox" id="cbDetox" name="cbDetox" className='add-only' value="Detox" />
                            Detox;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="checkbox" id="cbOtherDescribe_1" name="cbOtherDescribe_1" className='add-only' value="Other/Describe" />
                            Other/Describe:
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <textarea id="txtOtherDescribe_1" name="txtOtherDescribe_1" className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <th className='w-150'>
                            <span className='eleHeader'>SUBSTANCE TYPE</span>

                            <span className='small'>Include all used in last 30 days</span>
                        </th>
                        <th className='w-75'>
                            <span className='eleHeader'>AGE OF
                                <br />
                                1ST USE</span>

                        </th>
                        <th className='w-75'>
                            <span className='eleHeader'>YEARS IN
                                <br />
                                LIFETIME</span>

                        </th>
                        <th className='w-75'>
                            <span className='eleHeader'>DAYS IN
                                <br />
                                PAST 30</span>

                        </th>
                        <th className='w-75'>
                            <span className='eleHeader'>DAYS SINCE
                                <br />
                                LAST USE</span>

                        </th>
                        <th className='w-100'>
                            <span className='eleHeader'>AMOUNT</span>
                        </th>
                        <th className='w-200'>
                            <span className='eleHeader'>ROUTE OF ADMINISTRATION</span>
                        </th>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type="text" id="txtSA_1_1" name="txtSA_1_1" className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type="text" id="txtSA_1_2" name="txtSA_1_2" className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type="text" id="txtSA_1_3" name="txtSA_1_3" className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type="text" id="txtSA_1_4" name="txtSA_1_4" className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type="text" id="txtSA_1_5" name="txtSA_1_5" className='add-only' />
                        </td>
                        <td className='w-100'>
                            <input type="text" id="txtSA_1_6" name="txtSA_1_6" className='add-only' />
                        </td>
                        <td className='w-200'>
                            <input type="checkbox" id="cbSA_1_7" name="cbSA_1_7" className='add-only' value="Oral" /> Oral; &nbsp;
                            <input type="checkbox" id="cbSA_1_8" name="cbSA_1_8" className='add-only' value="Nasal" /> Nasal; &nbsp;
                            <input type="checkbox" id="cbSA_1_9" name="cbSA_1_9" className='add-only' value="Smoking" /> Smoking; &nbsp;
                            <input type="checkbox" id="cbSA_1_10" name="cbSA_1_10" className='add-only' value="Non-IV Injxn" /> Non-IV Injxn; &nbsp;
                            <input type="checkbox" id="cbSA_1_11" name="cbSA_1_11" className='add-only' value="IV" /> IV
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type="text" id="txtSA_2_1" name="txtSA_2_1" className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type="text" id="txtSA_2_2" name="txtSA_2_2" className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type="text" id="txtSA_2_3" name="txtSA_2_3" className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type="text" id="txtSA_2_4" name="txtSA_2_4" className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type="text" id="txtSA_2_5" name="txtSA_2_5" className='add-only' />
                        </td>
                        <td className='w-100'>
                            <input type="text" id="txtSA_2_6" name="txtSA_2_6" className='add-only' />
                        </td>
                        <td className='w-200'>
                            <input type="checkbox" id="cbSA_2_7" name="cbSA_2_7" className='add-only' value="Oral" /> Oral; &nbsp;
                            <input type="checkbox" id="cbSA_2_8" name="cbSA_2_8" className='add-only' value="Nasal" /> Nasal; &nbsp;
                            <input type="checkbox" id="cbSA_2_9" name="cbSA_2_9" className='add-only' value="Smoking" /> Smoking; &nbsp;
                            <input type="checkbox" id="cbSA_2_10" name="cbSA_2_10" className='add-only' value="Non-IV Injxn" /> Non-IV Injxn; &nbsp;
                            <input type="checkbox" id="cbSA_2_11" name="cbSA_2_11" className='add-only' value="IV" /> IV
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type="text" id="txtSA_3_1" name="txtSA_3_1" className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type="text" id="txtSA_3_2" name="txtSA_3_2" className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type="text" id="txtSA_3_3" name="txtSA_3_3" className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type="text" id="txtSA_3_4" name="txtSA_3_4" className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type="text" id="txtSA_3_5" name="txtSA_3_5" className='add-only' />
                        </td>
                        <td className='w-100'>
                            <input type="text" id="txtSA_3_6" name="txtSA_3_6" className='add-only' />
                        </td>
                        <td className='w-200'>
                            <input type="checkbox" id="cbSA_3_7" name="cbSA_3_7" className='add-only' value="Oral" /> Oral; &nbsp;
                            <input type="checkbox" id="cbSA_3_8" name="cbSA_3_8" className='add-only' value="Nasal" /> Nasal; &nbsp;
                            <input type="checkbox" id="cbSA_3_9" name="cbSA_3_9" className='add-only' value="Smoking" /> Smoking; &nbsp;
                            <input type="checkbox" id="cbSA_3_10" name="cbSA_3_10" className='add-only' value="Non-IV Injxn" /> Non-IV Injxn; &nbsp;
                            <input type="checkbox" id="cbSA_3_11" name="cbSA_3_11" className='add-only' value="IV" /> IV
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type="text" id="txtSA_4_1" name="txtSA_4_1" className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type="text" id="txtSA_4_2" name="txtSA_4_2" className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type="text" id="txtSA_4_3" name="txtSA_4_3" className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type="text" id="txtSA_4_4" name="txtSA_4_4" className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type="text" id="txtSA_4_5" name="txtSA_4_5" className='add-only' />
                        </td>
                        <td className='w-100'>
                            <input type="text" id="txtSA_4_6" name="txtSA_4_6" className='add-only' />
                        </td>
                        <td className='w-200'>
                            <input type="checkbox" id="cbSA_4_7" name="cbSA_4_7" className='add-only' value="Oral" /> Oral; &nbsp;
                            <input type="checkbox" id="cbSA_4_8" name="cbSA_4_8" className='add-only' value="Nasal" /> Nasal; &nbsp;
                            <input type="checkbox" id="cbSA_4_9" name="cbSA_4_9" className='add-only' value="Smoking" /> Smoking; &nbsp;
                            <input type="checkbox" id="cbSA_4_10" name="cbSA_4_10" className='add-only' value="Non-IV Injxn" /> Non-IV Injxn; &nbsp;
                            <input type="checkbox" id="cbSA_4_11" name="cbSA_4_11" className='add-only' value="IV" /> IV
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type="text" id="txtSA_5_1" name="txtSA_5_1" className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type="text" id="txtSA_5_2" name="txtSA_5_2" className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type="text" id="txtSA_5_3" name="txtSA_5_3" className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type="text" id="txtSA_5_4" name="txtSA_5_4" className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type="text" id="txtSA_5_5" name="txtSA_5_5" className='add-only' />
                        </td>
                        <td className='w-100'>
                            <input type="text" id="txtSA_5_6" name="txtSA_5_6" className='add-only' />
                        </td>
                        <td className='w-200'>
                            <input type="checkbox" id="cbSA_5_7" name="cbSA_5_7" className='add-only' value="Oral" /> Oral; &nbsp;
                            <input type="checkbox" id="cbSA_5_8" name="cbSA_5_8" className='add-only' value="Nasal" /> Nasal; &nbsp;
                            <input type="checkbox" id="cbSA_5_9" name="cbSA_5_9" className='add-only' value="Smoking" /> Smoking; &nbsp;
                            <input type="checkbox" id="cbSA_5_10" name="cbSA_5_10" className='add-only' value="Non-IV Injxn" /> Non-IV Injxn; &nbsp;
                            <input type="checkbox" id="cbSA_5_11" name="cbSA_5_11" className='add-only' value="IV" /> IV
                        </td>
                    </tr>
                </table>
                <h2>Physical</h2>
                <p className='w-750'>
                    <span className='eleHeader'>V. CURRENT MEDICAL CONDITIONS</span>
                    <span className='small'>(Check all that apply)</span>
                </p>
                <table>
                    <tr>
                        <td className='w-750'>
                            <input type="checkbox" id="cbPregnant" name="cbPregnant" className='add-only' value="Pregnant" />
                            Pregnant
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span><b>Due date:</b></span>&nbsp;
                            <input type="date" id="txtDueDate" name="txtDueDate" className='add-only w-250 custom-add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span><b>Prenatal care:</b></span>&nbsp;
                            <input type="text" id="txtPrenatalCare" name="txtPrenatalCare" className='add-only w-250 custom-add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbNoneReported" name="cbNoneReported" className='add-only' value="None Reported" />
                            None Reported
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbCongestiveHeartFailure" name="cbCongestiveHeartFailure" className='add-only' value="Congestive Heart Failure" />
                            Congestive Heart Failure
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbAsthma" name="cbAsthma" className='add-only' value="Asthma" />
                            Asthma
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbSeizure" name="cbSeizure" className='add-only' value="Seizure" />
                            Seizure
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbCancer" name="cbCancer" className='add-only' value="Cancer" />
                            Cancer
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbUnderweight" name="cbUnderweight" className='add-only' value="Underweight" />
                            Underweight
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbHighBloodPressure" name="cbHighBloodPressure" className='add-only' value="High Blood Pressure" />
                            High Blood Pressure
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbStroke" name="cbStroke" className='add-only' value="Stroke" />
                            Stroke
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbEmphysema" name="cbEmphysema" className='add-only' value="Emphysema" />
                            Emphysema
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbCirrhosis" name="cbCirrhosis" className='add-only' value="Cirrhosis" />
                            Ulcers
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbChronicPain" name="cbChronicPain" className='add-only' value="Chronic Pain" />
                            Chronic Pain
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbOverweight" name="cbOverweight" className='add-only' value="Overweight" />
                            Overweight
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbHeartDisease" name="cbHeartDisease" className='add-only' value="Heart Disease" />
                            Heart Disease
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbDiabetes" name="cbDiabetes" className='add-only' value="Diabetes" />
                            Diabetes
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbEpilepsy" name="cbEpilepsy" className='add-only' value="Epilepsy" />
                            Epilepsy
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbDigestiveProblems" name="cbDigestiveProblems" className='add-only' value="Digestive Problems" />
                            Digestive Problems
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbThyroidDisease" name="cbThyroidDisease" className='add-only' value="Thyroid Disease" />
                            Thyroid Disease
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbSexuallyTransmitted" name="cbSexuallyTransmitted" className='add-only' value="Sexually Transmitted Dz" />
                            STD
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="checkbox" id="cbOther" name="cbOther" className='add-only' value="Other" />
                            Other/Describe:
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <textarea id="txtOther_1" name="txtOther_1" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>VI. CURRENT & PAST MEDICATIONS</span>
                    <span className='small'>(Including non-psychotropic medications)</span>
                </p>
                <table>
                    <tr>
                        <td className='w-200'><span><strong>Medication Name</strong></span></td>
                        <td className='w-75'><span><strong>Dose</strong></span></td>
                        <td className='w-75'><span><strong>Freq.</strong></span> </td>
                        <td className='w-75'><span><strong>Route</strong></span></td>
                        <td className='w-75'><span><strong>Current</strong></span></td>
                        <td className='w-250'><strong>COMMENTS (Reason Prescribed/Response, etc.)</strong></td>
                    </tr>
                    <tr>
                        <td className='w-200'>
                            <input type='text' id="txtMedicationName_1" name="txtMedicationName_1" className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type='text' id="txtDose_1" name="txtDose_1" className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type='text' id="txtFreq_1" name="txtFreq_1" className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type='text' id="txtRoute_1" name="txtRoute_1" className='add-only' />
                        </td>
                        <td className='w-75'>
                            <select id="ddlCurrent_1" name="ddlCurrent_1" className='add-only'>
                                <option value="NA"></option>
                                <option value="Yes">Yes</option>
                                <option value="No">No</option>
                            </select>
                        </td>
                        <td className='w-250'>
                            <input type='text' id="txtcomment_1" name="txtcomment_1" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-200'>
                            <input type='text' id="txtMedicationName_2" name="txtMedicationName_2" className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type='text' id="txtDose_2" name="txtDose_2" className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type='text' id="txtFreq_2" name="txtFreq_2" className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type='text' id="txtRoute_2" name="txtRoute_2" className='add-only' />
                        </td>
                        <td className='w-75'>
                            <select id="ddlCurrent_2" name="ddlCurrent_1" className='add-only'>
                                <option value="NA"></option>
                                <option value="Yes">Yes</option>
                                <option value="No">No</option>
                            </select>
                        </td>
                        <td className='w-250'>
                            <input type='text' id="txtcomment_2" name="txtcomment_2" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-200'>
                            <input type='text' id="txtMedicationName_3" name="txtMedicationName_3" className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type='text' id="txtDose_3" name="txtDose_3" className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type='text' id="txtFreq_3" name="txtFreq_3" className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type='text' id="txtRoute_3" name="txtRoute_3" className='add-only' />
                        </td>
                        <td className='w-75'>
                            <select id="ddlCurrent_3" name="ddlCurrent_1" className='add-only'>
                                <option value="NA"></option>
                                <option value="Yes">Yes</option>
                                <option value="No">No</option>
                            </select>
                        </td>
                        <td className='w-250'>
                            <input type='text' id="txtcomment_3" name="txtcomment_3" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-200'>
                            <input type='text' id="txtMedicationName_4" name="txtMedicationName_4" className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type='text' id="txtDose_4" name="txtDose_4" className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type='text' id="txtFreq_4" name="txtFreq_4" className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type='text' id="txtRoute_4" name="txtRoute_4" className='add-only' />
                        </td>
                        <td className='w-75'>
                            <select id="ddlCurrent_4" name="ddlCurrent_1" className='add-only'>
                                <option value="NA"></option>
                                <option value="Yes">Yes</option>
                                <option value="No">No</option>
                            </select>
                        </td>
                        <td className='w-250'>
                            <input type='text' id="txtcomment_4" name="txtcomment_4" className='add-only' />
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>VII. ALLERGIES</span>
                </p>
                <table>
                    <tr>
                        <td className='w-750'>
                            <input type="checkbox" id="cbNoReportedDrug" name="cbNoReportedDrug" className='add-only' value="No Reported Drug or Food Allergies" />
                            No Reported Drug or Food Allergies;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="checkbox" id="cbOtherDescribe_2" name="cbOtherDescribe_2" className='add-only' value="Other/Describe" />
                            Other/Describe:
                            <input type='text' id="txtOtherDescribe_2" name="txtOtherDescribe_2" className='add-only w-250 custom-add-only' />
                        </td>
                    </tr>
                </table>
                <h2>VIII. PRIMARY CARE PHYSICIAN</h2>
                <table>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>Name</span>
                            <input type="text" id="txtName" name="txtName" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Phone</span>
                            <input type="text" id="txtPhone" name="txtPhone" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>FAX</span>
                            <input type="text" id="txtFax" name="txtFax" className='add-only' />
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>IX. ADDITIONAL SIGNIFICANT MEDICAL/ DEVELOPMENTAL HISTORY</span>
                    <span className='small'>(Diagnosis, Hospitalizations, Surgery, labs values, status of conditions, etc.)</span>
                    <textarea id="txtAdditionalSignMedicalHistory" name="txtAdditionalSignMedicalHistory" className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <h4>1. During pregnancy did this person's mother:</h4>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>(a) Receive health care?</span>
                    <input type="radio" id="rbHealthCare_Unknown" name="rbHealthCare" value="Unknown" className='add-only' /> Unknown &nbsp;
                    <input type="radio" id="cbHealthCare_No" name="cbHealthCare" value="No" className='add-only' /> No &nbsp;
                    <input type="radio" id="cbHealthCare_Yes" name="cbHealthCare" value="Yes" className='add-only' /> Yes - Specify  &nbsp;
                    <input type="text" id="txtHealthCare_Specify" name="txtHealthCare_Specify" className='add-only w-500 custom-add-only' />
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>(b) Drink alcohol? </span>
                    <input type="radio" id="rbDrinkAlcohol_Unknown" name="rbDrinkAlcohol" value="Unknown" className='add-only' /> Unknown &nbsp;
                    <input type="radio" id="rbDrinkAlcohol_No" name="rbDrinkAlcohol" value="No" className='add-only' /> No &nbsp;
                    <input type="radio" id="rbDrinkAlcohol_Yes" name="rbDrinkAlcohol" value="Yes" className='add-only' /> Yes - Specify  &nbsp;
                    <input type="text" id="txtDrinkAlcohol_Specify" name="txtDrinkAlcohol_Specify" className='add-only w-500 custom-add-only' />
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>(c) Use tabacco? </span>
                    <input type="radio" id="rbUseTabacco_Unknown" name="rbUseTabacco" value="Unknown" className='add-only' /> Unknown &nbsp;
                    <input type="radio" id="rbUseTabacco_No" name="rbUseTabacco" value="No" className='add-only' /> No &nbsp;
                    <input type="radio" id="rbUseTabacco_Yes" name="rbUseTabacco" value="Yes" className='add-only' /> Yes - Specify  &nbsp;
                    <input type="text" id="txtUseTabacco_Specify" name="txtUseTabacco_Specify" className='add-only w-500 custom-add-only' />
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>(d) Use any illicit drugs? </span>
                    <input type="radio" id="rbIlliciDrugs_Unknown" name="rbIlliciDrugs" value="Unknown" className='add-only' /> Unknown &nbsp;
                    <input type="radio" id="rbIlliciDrugs_No" name="rbIlliciDrugs" value="No" className='add-only' /> No &nbsp;
                    <input type="radio" id="rbIlliciDrugs_Yes" name="rbIlliciDrugs" value="Yes" className='add-only' /> Yes - Specify  &nbsp;
                    <input type="text" id="txtIlliciDrugs_Specify" name="txtIlliciDrugs_Specify" className='add-only w-500 custom-add-only' />
                </p>
                <p className='w-750'>
                    <span className='eleHeader'> (e) Use any medications?</span>
                    <input type="radio" id="rbMedications_Unknown" name="rbMedications" value="Unknown" className='add-only' /> Unknown &nbsp;
                    <input type="radio" id="rbMedications_No" name="rbMedications" value="No" className='add-only' /> No &nbsp;
                    <input type="radio" id="rbMedications_Yes" name="rbMedication" value="Yes" className='add-only' /> Yes - Specify  &nbsp;
                    <input type="text" id="txtMedications_Specify" name="txtMedications_Specify" className='add-only w-500 custom-add-only' />
                </p>
                <p className='w-750'>
                    <span className='eleHeader'> (f) Have any medical and emotional problems?</span>
                    <input type="radio" id="rbEmotionalProblems_Unknown" name="rbEmotionalProblems" value="Unknown" className='add-only' /> Unknown &nbsp;
                    <input type="radio" id="rbEmotionalProblems_No" name="rbEmotionalProblems" value="No" className='add-only' /> No &nbsp;
                    <input type="radio" id="rbEmotionalProblems_Yes" name="rbEmotionalProblems" value="Yes" className='add-only' /> Yes -Specify &nbsp;
                    <input type="text" id="txtEmotionalProblems_Specify" name="txtEmotionalProblems_Specify" className='add-only w-500 custom-add-only' />
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>(g) Experience complications during labor delivery? </span>
                    <input type="radio" id="rbLabourDelivery_Unknown" name="rbLabourDelivery" value="Unknown" className='add-only' /> Unknown &nbsp;
                    <input type="radio" id="rbLabourDelivery_No" name="rbLabourDelivery" value="No" className='add-only' /> No &nbsp;
                    <input type="radio" id="rbLabourDelivery_Yes" name="rbLabourDelivery" value="Yes" className='add-only' /> Yes -Specify &nbsp;
                    <input type="text" id="txtLabourDelivery_Specify" name="txtLabourDelivery_Specify" className='add-only w-500 custom-add-only' />
                </p>
                <p className='w-750'>
                    <span className='eleHeader'> (h) Give birth prematurely?</span>
                    <input type="radio" id="rbBirthPrematurely_Unknown" name="rbBirthPrematurely" value="Unknown" className='add-only' /> Unknown &nbsp;
                    <input type="radio" id="rbBirthPrematurely_No" name="rbBirthPrematurely" value="No" className='add-only' /> No &nbsp;
                    <input type="radio" id="rbBirthPrematurely_Yes" name="rbBirthPrematurely" value="Yes" className='add-only' /> Yes -Specify &nbsp;
                    <input type="text" id="txtBirthPrematurely_Specify" name="txtBirthPrematurely_Specify" className='add-only w-500 custom-add-only' />
                </p>


                <p className='w-750'>
                    <h4>2. Timing of Developmental Events</h4>
                </p>

                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>(a) &nbsp; By 0-1 year of age,had this person: </span></td>
                    </tr>
                    <tr>
                        <td className='w-300'><b>Sat Up?</b></td>
                        <td className='w-450'>
                            <input type="radio" id="rbSatUp_Unknown" name="rbSatUp" value="Unknown" className='add-only' /> Unknown &nbsp;
                            <input type="radio" id="rbSatUp_Yes" name="rbSatUp" value="Yes" className='add-only' /> Yes &nbsp;
                            <input type="radio" id="rbSatUp_No" name="rbSatUp" value="No" className='add-only' /> No
                        </td>
                    </tr>
                    <tr>
                        <td className='w-300'><b>Crawled?</b></td>
                        <td className='w-450'>
                            <input type="radio" id="rbCrawled_Unknown" name="rbCrawled" value="Unknown" className='add-only' /> Unknown &nbsp;
                            <input type="radio" id="rbCrawled_Yes" name="rbCrawled" value="Yes" className='add-only' /> Yes &nbsp;
                            <input type="radio" id="rbCrawled_No" name="rbCrawled" value="No" className='add-only' /> No &nbsp;
                        </td>
                    </tr>

                    <tr>
                        <td className='w-750'><span className='eleHeader'>(b) By 1-2 year of age,had this person:</span></td>
                    </tr>
                    <tr>
                        <td className='w-300'><b>Walked alone?</b></td>
                        <td className='w-450'>
                            <input type="radio" id="rbWalkedAlone_Unknown" name="rbWalkedAlone" value="Unknown" className='add-only' /> Unknown &nbsp;
                            <input type="radio" id="rbWalkedAlone_Yes" name="rbWalkedAlone" value="Yes" className='add-only' /> Yes &nbsp;
                            <input type="radio" id="rbWalkedAlone_No" name="rbWalkedAlone" value="No" className='add-only' /> No
                        </td>
                    </tr>
                    <tr>
                        <td className='w-300'><b>Used first words?</b></td>
                        <td className='w-450'>
                            <input type="radio" id="rbFirstWords_Unknown" name="rbFirstWords" value="Unknown" className='add-only' /> Unknown &nbsp;
                            <input type="radio" id="rbFirstWords_Yes" name="rbFirstWords" value="Yes" className='add-only' /> Yes &nbsp;
                            <input type="radio" id="rbFirstWords_No" name="rbFirstWords" value="No" className='add-only' /> No
                        </td>
                    </tr>
                    <tr>
                        <td className='w-300'><b>Fed self with spoon?</b></td>
                        <td className='w-450'>
                            <input type="radio" id="rbFedSelf_Unknown" name="rbFedSelf" value="Unknown" className='add-only' /> Unknown &nbsp;
                            <input type="radio" id="rbFedSelf_Yes" name="rbFedSelf" value="Yes" className='add-only' /> Yes &nbsp;
                            <input type="radio" id="rbFedSelf_No" name="rbFedSelf" value="No" className='add-only' /> No
                        </td>
                    </tr>

                    <tr>
                        <td className='w-750'><span className='eleHeader'>(c) &nbsp; By 3-5 year of age,had this person:</span> </td>
                    </tr>
                    <tr>
                        <td className='w-300'><b>Been toilet trained?</b></td>
                        <td className='w-450'>
                            <input type="radio" id="rbToiletTrained_Unknown" name="rbToiletTrained" value="Unknown" className='add-only' /> Unknown &nbsp;
                            <input type="radio" id="rbToiletTrained_Yes" name="rbToiletTrained" value="Yes" className='add-only' /> Yes &nbsp;
                            <input type="radio" id="rbToiletTrained_No" name="rbToiletTrained" value="No" className='add-only' /> No
                        </td>
                    </tr>
                    <tr>
                        <td className='w-300'><b>Used first sentences?</b></td>
                        <td className='w-450'>
                            <input type="radio" id="rbFirstSentences_Unknown" name="rbFirstSentences" value="Unknown" className='add-only' /> Unknown &nbsp;
                            <input type="radio" id="rbFirstSentences_Yes" name="rbFirstSentences" value="Yes" className='add-only' /> Yes &nbsp;
                            <input type="radio" id="rbFirstSentences_No" name="rbFirstSentences" value="No" className='add-only' /> No
                        </td>
                    </tr>
                    <tr>
                        <td className='w-300'><b>Learned to ride a tricycle?</b></td>
                        <td className='w-450'>
                            <input type="radio" id="rbRideTricycle_Unknown" name="rbRideTricycle" value="Unknown" className='add-only' /> Unknown &nbsp;
                            <input type="radio" id="rbRideTricycle_Yes" name="rbRideTricycle" value="Yes" className='add-only' /> Yes &nbsp;
                            <input type="radio" id="rbRideTricycle_No" name="rbRideTricycle" value="No" className='add-only' /> No
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>Please explain any "NO":</span>
                    <textarea id="txtExplainNo" name="txtExplainNo" className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <h4>3. Other Developmental Issues.Indicate below if the person ever experienced any of the following:</h4>
                </p>

                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>(a) Could not gain weight</span>
                            <input type="radio" id="rbGainWeight_No" name="rbGainWeight" value="No" className='add-only' /> No &nbsp;
                            <input type="radio" id="rbGainWeight_Yes" name="rbGainWeight" value="Yes" className='add-only' /> Yes,age begin &nbsp;
                            <input type="text" id="txtGainWeight_1" name="txtGainWeight_1" className='add-only w-100 custom-add-only' /> and if resolved,when &nbsp;
                            <input type="text" id="txtGainWeight_2" name="txtGainWeight_2" className='add-only w-100 custom-add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>(b) Wet the bed or soiled his/her clothes</span>
                            <input type="radio" id="rbSoiledClothes_No" name="rbSoiledClothes" value="No" className='add-only' /> No &nbsp;
                            <input type="radio" id="rbSoiledClothes_Yes" name="rbSoiledClothes" value="Yes" className='add-only' /> Yes,age begin &nbsp;
                            <input type="text" id="txtSoiledClothes_1" name="txtSoiledClothes_1" className='add-only w-100 custom-add-only' /> and if resolved,when &nbsp;
                            <input type="text" id="txtSoiledClothes_2" name="txtSoiledClothes_2" className='add-only w-100 custom-add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>(c) Had difficulty with coordination</span>
                            <input type="radio" id="rbCoordination_No" name="rbCoordination" value="No" className='add-only' /> No &nbsp;
                            <input type="radio" id="rbCoordination_Yes" name="rbCoordination" value="Yes" className='add-only' /> Yes,age begin &nbsp;
                            <input type="text" id="txtCoordination_1" name="txtCoordination_1" className='add-only w-100 custom-add-only' /> and if resolved,when &nbsp;
                            <input type="text" id="txtCoordination_2" name="txtCoordination_2" className='add-only w-100 custom-add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>(d) Had difficulty with speech</span>
                            <input type="radio" id="rbSpeech_No" name="rbSpeech" value="No" className='add-only' /> No &nbsp;
                            <input type="radio" id="rbSpeech_Yes" name="rbSpeech" value="Yes" className='add-only' /> Yes,age begin &nbsp;
                            <input type="text" id="txtSpeech_1" name="txtSpeech_1" className='add-only w-100 custom-add-only' /> and if resolved,when &nbsp;
                            <input type="text" id="txtSpeech_2" name="txtSpeech_2" className='add-only w-100 custom-add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>(e) Had unusual sensitivity to touch</span>
                            <input type="radio" id="rbUnusualSensitivity_No" name="rbUnusualSensitivity" value="No" className='add-only' /> No &nbsp;
                            <input type="radio" id="rbUnusualSensitivity_Yes" name="rbUnusualSensitivity" value="Yes" className='add-only' /> Yes,age begin  &nbsp;
                            <input type="text" id="txtUnusualSensitivity_1" name="txtUnusualSensitivity_1" className='add-only w-100 custom-add-only' /> and if resolved,when &nbsp;
                            <input type="text" id="txtUnusualSensitivity_2" name="txtUnusualSensitivity_2" className='add-only w-100 custom-add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>(f) Had difficulty with social skills</span>
                            <input type="radio" id="rbSocialSkills_No" name="rbSocialSkills" value="No" className='add-only' /> No &nbsp;
                            <input type="radio" id="rbSocialSkills_Yes" name="rbSocialSkills" value="Yes" className='add-only' /> Yes,age begin &nbsp;
                            <input type="text" id="txtSocialSkills_1" name="txtSocialSkills_1" className='add-only w-100 custom-add-only' /> and if resolved,when &nbsp;
                            <input type="text" id="txtSocialSkills_2" name="txtSocialSkills_2" className='add-only w-100 custom-add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>(g) Was evaluated for taking too much time to develop certain skills(eg.communication,reading,spelling)</span>
                            <input type="radio" id="rbCertainSkills_No" name="rbCertainSkills" value="No" className='add-only' /> No &nbsp;
                            <input type="radio" id="rbCertainSkills_Yes" name="rbCertainSkills" value="Yes" className='add-only' /> Yes &nbsp;
                            <input type="radio" id="rbCertainSkills_Unknown" name="rbCertainSkills" value="Unknown" className='add-only' /> Unknown
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>(h) Was evaluated for speech's and language delays?</span>
                            <input type="radio" id="rbLanguageDelays_No" name="rbLanguageDelays" value="No" className='add-only' /> No &nbsp;
                            <input type="radio" id="rbLanguageDelays_Yes" name="rbLanguageDelays" value="Yes" className='add-only' /> Yes &nbsp;
                            <input type="radio" id="rbLanguageDelays_Unknown" name="rbLanguageDelays" value="Unknown" className='add-only' /> Unknown
                        </td>
                    </tr>
                </table>

                <p className='w-750'>
                    4. Please explain any findings above and provide any additional information that might be helpful regarding any other issues or significant
                    events:
                    <textarea id="txtLegalExplain_Comment" name="txtLegalExplain_Comment" className='add-only'></textarea>
                </p>
                <h2>SOCIAL</h2>
                <h3>X. LEGAL STATUS</h3>
                <p className='w-750'>
                    <span className='eleHeader'>Current Legal Status:</span>
                </p>
                <table>
                    <tr>
                        <td className='w-187'>
                            <input type="checkbox" id="cbLegal_1" name="cbLegal_1" className='add-only' value="None" />
                            None;
                        </td>
                        <td className='w-187'>
                            <input type="checkbox" id="cbLegal_2" name="cbLegal_2" className='add-only' value="Probation" />
                            Probation;
                        </td>
                        <td className='w-187'>
                            <input type="checkbox" id="cbLegal_3" name="cbLegal_3" className='add-only' value="Charges Pending" />
                            Charges Pending;
                        </td>
                        <td className='w-187'>
                            <input type="checkbox" id="cbLegal_4" name="cbLegal_4" className='add-only' value="DCFS" />
                            DCFS;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type="checkbox" id="cbLegal_5" name="cbLegal_5" className='add-only' value="OJJ" />
                            OJJ;
                        </td>
                        <td className='w-187'></td>
                        <td className='w-187'></td>
                        <td className='w-187'></td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="checkbox" id="cbLegal_6" name="cbLegal_6" className='add-only' value="Other" />
                            Other
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>Comment/Detail:</span>
                    <textarea id="txtLegal_Comment" name="txtLegal_Comment" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Past Legal Status:</span>
                </p>
                <table>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbPastLegal_1" name="cbPastLegal_1" className='add-only' value="None" />
                            None;
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbPastLegal_2" name="cbPastLegal_2" className='add-only' value="DCFS" />
                            DCFS;
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbPastLegal_3" name="cbPastLegal_3" className='add-only' value="OJJ" />
                            OJJ;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="checkbox" id="cbPastLegal_4" name="cbPastLegal_4" className='add-only' value="Other" />
                            Other
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>Comment/Detail:</span>
                    <textarea id="txtPastLegal_Comment" name="txtPastLegal_Comment" className='add-only'></textarea>
                </p>
                <h2>XI. FAMILY HISTORY
                    <span className='small'>(relationship status with relatives, family involvement in treatment, and living status of significant relatives):</span>
                </h2>
                <p className='w-750'>
                    <span className='eleHeader'>Custodial Status:</span>
                </p>
                <table>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbCustodial_1" name="cbCustodial_1" className='add-only' value="Independant Adult" />
                            Independant Adult;
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbCustodial_2" name="cbCustodial_2" className='add-only' value="Biologic Father" />
                            Biologic Father;
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbCustodial_3" name="cbCustodial_3" className='add-only' value="Biologic Mother" />
                            Biologic Mother;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbCustodial_4" name="cbCustodial_4" className='add-only' value="Joint Biologic Parents" />
                            Joint Biologic Parents;
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbCustodial_5" name="cbCustodial_5" className='add-only' value="Govt/Judicial" />
                            Gov't/Judicial;
                        </td>
                        <td className='w-250'>&nbsp;</td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="checkbox" id="cbCustodial_6" name="cbCustodial_6" className='add-only' value="Other" />
                            Other:
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <textarea id="txtCustodial_Other" name="txtCustodial_Other" className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Adverse Circumstances in Family of Origin:</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbAdverseFOO_1" name="cbAdverseFOO_1" className='add-only' value="NA" />
                            N/A;
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbAdverseFOO_2" name="cbAdverseFOO_2" className='add-only' value="Poverty" />
                            Poverty;
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbAdverseFOO_3" name="cbAdverseFOO_3" className='add-only' value="Criminal Behavior" />
                            Criminal Behavioral;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbAdverseFOO_4" name="cbAdverseFOO_4" className='add-only' value="Mental Illness" />
                            Mental Illness;
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbAdverseFOO_5" name="cbAdverseFOO_5" className='add-only' value="Substance Use" />
                            Substance Use;
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbAdverseFOO_6" name="cbAdverseFOO_6" className='add-only' value="Abuse" />
                            Abuse;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbAdverseFOO_7" name="cbAdverseFOO_7" className='add-only' value="Neglect" />
                            Neglect;
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbAdverseFOO_8" name="cbAdverseFOO_8" className='add-only' value="Domestic Violence" />
                            Domestic Violence;
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbAdverseFOO_9" name="cbAdverseFOO_9" className='add-only' value="Violence" />
                            Violence;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbAdverseFOO_10" name="cbAdverseFOO_10" className='add-only' value="Trauma" />
                            Trauma;
                        </td>
                        <td className='w-250'>&nbsp;</td>
                    </tr>
                </table>
                <p className='w-750'>
                    <input type="checkbox" id="cbOtherDescribe_3" name="cbOtherDescribe_3" className='add-only' value="Other/Describe" />
                    Other/Describe:
                    <textarea id="txtOtherDescribe_3" name="txtOtherDescribe_3" className='add-only'></textarea>
                </p>
                <h2>XII. TRAUMA HISTORY</h2>
                <p className='w-750'>
                    <span className='eleHeader'>History of Trauma:</span>
                </p>
                <table>
                    <tr>
                        <td className='w-187'>
                            <input type="checkbox" id="cbTraumaHx_1" name="cbTraumaHx_1" className='add-only' value="None" />
                            None;
                        </td>
                        <td className='w-187'>
                            <input type="checkbox" id="cbTraumaHx_2" name="cbTraumaHx_1" className='add-only' value="Experienced" />
                            Experienced;
                        </td>
                        <td className='w-187'>
                            <input type="checkbox" id="cbTraumaHx_3" name="cbTraumaHx_1" className='add-only' value="Witnessed" />
                            Witnessed;
                        </td>
                        <td className='w-187'>
                            <input type="checkbox" id="cbTraumaHx_4" name="cbTraumaHx_4" className='add-only' value="Abuse" />
                            Abuse;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type="checkbox" id="cbTraumaHx_5" name="cbTraumaHx_5" className='add-only' value="Neglect" />
                            Neglect;
                        </td>
                        <td className='w-187'>
                            <input type="checkbox" id="cbTraumaHx_6" name="cbTraumaHx_6" className='add-only' value="Violence" />
                            Violence;
                        </td>
                        <td className='w-187'>
                            <input type="checkbox" id="cbTraumaHx_7" name="cbTraumaHx_7" className='add-only' value="Sexual Assault" />
                            Sexual Assault;
                        </td>
                        <td className='w-187'></td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="checkbox" id="cbTraumaHx_8" name="cbTraumaHx_8" className='add-only' value="Other/Describe" />
                            Other/Describe:
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <textarea id="txtOtherDescribe_6" name="txtOtherDescribe_6" className='add-only'></textarea>
                </p>
                <h3>XIII. LIVING SITUATION</h3>
                <span className='small'>(current status and functioning)</span>
                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>a. Primary Residence:</span></td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type="checkbox" id="cbResidence_ParentHome" name="cbResidence_ParentHome" value="Parent/Guardian Home" className='add-only' />Parent/Guardian Home;</td>
                        <td className='w-187'>
                            <input type="checkbox" id="cbResidence_RelativeHome" name="cbResidence_RelativeHome" value="Relative Home" className='add-only' />Relative's Home;</td>
                        <td className='w-187'>
                            <input type="checkbox" id="cbResidence_HomePlacement" name="cbResidence_HomePlacement" value="Out of Home placement" className='add-only' />Out of Home placement;</td>
                        <td className='w-187'>
                            <input type="checkbox" id="cbResidence_Homeless" name="cbResidence_Homeless" value="Homeless" className='add-only' />Homeless;</td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="checkbox" id="cbResidence_Other" name="cbResidence_Other" value="Other" className='add-only' />Other/Describe:
                            <input type="text" id="txtResidence_Other" name="txtResidence_Other" className='add-only' />
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>How long at current residence?</span>
                            <input type="text" id="txtLiving_Residence" name="txtLiving_Residence" className='add-only' />
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Family/Household Composition:</span>
                            <input type="text" id="txtLiving_Composition" name="txtLiving_Composition" className='add-only' />
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-100'>
                            <span className='eleHeader'>Person Nature of Relationship </span>
                        </td>
                        <td className='w-150'>
                            <span className='eleHeader'>Name </span>
                        </td>
                        <td className='w-50'>
                            <span className='eleHeader'>Age </span>
                        </td>
                        <td className='w-150'>
                            <span className='eleHeader'>Living/ Deceased</span>
                        </td>
                        <td className='w-100'>
                            <span className='eleHeader'>Quality of Relationship</span>
                        </td>
                        <td className='w-200'>
                            <span className='eleHeader'>Household</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-100'>Mother</td>
                        <td className='w-150'>
                            <input type="text" id="txtMother_Name" name="txtMother_Name" className='add-only' /></td>
                        <td className='w-50'>
                            <input type="text" id="txtMother_Age" name="txtMother_Age" className='add-only' /></td>
                        <td className='w-150'>
                            <input type="checkbox" id="cbMother_Living" name="cbMother_Living" value="Living" className='add-only' />Living
                            <br />
                            <input type="checkbox" id="cbMother_Deceased" name="cbMother_Deceased" value="Deceased" className='add-only' />Deceased
                        </td>
                        <td className='w-100'>
                            <input type="text" id="txtMother_Relationship" name="txtMother_Relationship" className='add-only' /></td>
                        <td className='w-200'>
                            <input type="checkbox" id="cbMother_Fulltime" name="cbMother_Fulltime" value="Lives with Fulltime" className='add-only' />Lives with Fulltime
                            <br />
                            <input type="checkbox" id="cbMother_Halftime" name="cbMother_Halftime" value="Lives with part-time" className='add-only' />Lives with part-time
                            <br />
                            <input type="checkbox" id="cbMother_NotLiveWith" name="cbMother_NotLiveWith" value="Does not live with" className='add-only' />Does not live with
                        </td>
                    </tr>
                    <tr>
                        <td className='w-100'>Father</td>
                        <td className='w-150'>
                            <input type="text" id="txtFather_Name" name="txtFather_Name" className='add-only' /></td>
                        <td className='w-50'>
                            <input type="text" id="txtFather_Age" name="txtFather_Age" className='add-only' /></td>
                        <td className='w-150'>
                            <input type="checkbox" id="cbFather_Living" name="cbFather_Living" value="Living" className='add-only' />Living
                            <br />
                            <input type="checkbox" id="cbFather_Deceased" name="cbFather_Deceased" value="Deceased" className='add-only' />Deceased
                        </td>
                        <td className='w-100'>
                            <input type="text" id="txtFather_Relationship" name="txtFather_Relationship" className='add-only' /></td>
                        <td className='w-200'>
                            <input type="checkbox" id="cbFather_Fulltime" name="cbFather_Fulltime" value="Lives with Fulltime" className='add-only' />Lives with Fulltime
                            <br />
                            <input type="checkbox" id="cbFather_Halftime" name="cbFather_Halftime" value="Lives with part-time" className='add-only' />Lives with part-time
                            <br />
                            <input type="checkbox" id="cbFather_NotLiveWith" name="cbFather_NotLiveWith" value="Does not live with" className='add-only' />Does not live with
                        </td>
                    </tr>
                    <tr>
                        <td className='w-100'>Sibling</td>
                        <td className='w-150'>
                            <input type="text" id="txtSibling_Name_1" name="txtSibling_Name_1" className='add-only' /></td>
                        <td className='w-50'>
                            <input type="text" id="txtSibling_Age_1" name="txtSibling_Age_1" className='add-only' /></td>
                        <td className='w-150'>
                            <input type="checkbox" id="cbSibling_Living_1" name="cbSibling_Living_1" value="Living" className='add-only' />Living
                            <br />
                            <input type="checkbox" id="cbSibling_Deceased_1" name="cbSibling_Deceased_1" value="Deceased" className='add-only' />Deceased
                        </td>
                        <td className='w-100'>
                            <input type="text" id="txtSibling_Relationship_1" name="txtSibling_Relationship_1" className='add-only' /></td>
                        <td className='w-200'>
                            <input type="checkbox" id="cbSibling_Fulltime_1" name="cbSibling_Fulltime_1" value="Lives with Fulltime" className='add-only' />Lives with Fulltime
                            <br />
                            <input type="checkbox" id="cbSibling_Halftime_1" name="cbSibling_Halftime_1" value="Lives with part-time" className='add-only' />Lives with part-time
                            <br />
                            <input type="checkbox" id="cbSibling_NotLiveWith_1" name="cbSibling_NotLiveWith_1" value="Does not live with" className='add-only' />Does not live with
                        </td>
                    </tr>
                    <tr>
                        <td className='w-100'>Sibling</td>
                        <td className='w-150'>
                            <input type="text" id="txtSibling_Name_2" name="txtSibling_Name_2" className='add-only' /></td>
                        <td className='w-50'>
                            <input type="text" id="txtSibling_Age_2" name="txtSibling_Age_2" className='add-only' /></td>
                        <td className='w-150'>
                            <input type="checkbox" id="cbSibling_Living_2" name="cbSibling_Living_2" value="Living" className='add-only' />Living
                            <br />
                            <input type="checkbox" id="cbSibling_Deceased_2" name="cbSibling_Deceased_2" value="Deceased" className='add-only' />Deceased
                        </td>
                        <td className='w-100'>
                            <input type="text" id="txtSibling_Relationship_2" name="txtSibling_Relationship_2" className='add-only' /></td>
                        <td className='w-200'>
                            <input type="checkbox" id="cbSibling_Fulltime_2" name="cbSibling_Fulltime_2" value="Lives with Fulltime" className='add-only' />Lives with Fulltime
                            <br />
                            <input type="checkbox" id="cbSibling_Halftime_2" name="cbSibling_Halftime_2" value="Lives with part-time" className='add-only' />Lives with part-time
                            <br />
                            <input type="checkbox" id="cbSibling_NotLiveWith_2" name="cbSibling_NotLiveWith_2" value="Does not live with" className='add-only' />Does not live with
                        </td>
                    </tr>
                    <tr>
                        <td className='w-100'>Sibling</td>
                        <td className='w-150'>
                            <input type="text" id="txtSibling_Name_3" name="txtSibling_Name_3" className='add-only' /></td>
                        <td className='w-50'>
                            <input type="text" id="txtSibling_Age_3" name="txtSibling_Age_3" className='add-only' /></td>
                        <td className='w-150'>
                            <input type="checkbox" id="cbSibling_Living_3" name="cbSibling_Living_3" value="Living" className='add-only' />Living
                            <br />
                            <input type="checkbox" id="cbSibling_Deceased_3" name="cbSibling_Deceased_3" value="Deceased" className='add-only' />Deceased
                        </td>
                        <td className='w-100'>
                            <input type="text" id="txtSibling_Relationship_3" name="txtSibling_Relationship_3" className='add-only' /></td>
                        <td className='w-200'>
                            <input type="checkbox" id="cbSibling_Fulltime_3" name="cbSibling_Fulltime_3" value="Lives with Fulltime" className='add-only' />Lives with Fulltime
                            <br />
                            <input type="checkbox" id="cbSibling_Halftime_3" name="cbSibling_Halftime_3" value="Lives with part-time" className='add-only' />Lives with part-time
                            <br />
                            <input type="checkbox" id="cbSibling_NotLiveWith_3" name="cbSibling_NotLiveWith_3" value="Does not live with" className='add-only' />Does not live with
                        </td>
                    </tr>
                    <tr>
                        <td className='w-100'>Sibling</td>
                        <td className='w-150'>
                            <input type="text" id="txtSibling_Name_4" name="txtSibling_Name_4" className='add-only' /></td>
                        <td className='w-50'>
                            <input type="text" id="txtSibling_Age_4" name="txtSibling_Age_4" className='add-only' /></td>
                        <td className='w-150'>
                            <input type="checkbox" id="cbSibling_Living_4" name="cbSibling_Living_4" value="Living" className='add-only' />Living
                            <br />
                            <input type="checkbox" id="cbSibling_Deceased_4" name="cbSibling_Deceased_4" value="Deceased" className='add-only' />Deceased
                        </td>
                        <td className='w-100'>
                            <input type="text" id="txtSibling_Relationship_4" name="txtSibling_Relationship_4" className='add-only' /></td>
                        <td className='w-200'>
                            <input type="checkbox" id="cbSibling_Fulltime_4" name="cbSibling_Fulltime_4" value="Lives with Fulltime" className='add-only' />Lives with Fulltime
                            <br />
                            <input type="checkbox" id="cbSibling_Halftime_4" name="cbSibling_Halftime_4" value="Lives with part-time" className='add-only' />Lives with part-time
                            <br />
                            <input type="checkbox" id="cbSibling_NotLiveWith_4" name="cbSibling_NotLiveWith_4" value="Does not live with" className='add-only' />Does not live with
                        </td>
                    </tr>
                    <tr>
                        <td className='w-100'>Stepfather</td>
                        <td className='w-150'>
                            <input type="text" id="txtStepfather_Name" name="txtStepfather_Name" className='add-only' /></td>
                        <td className='w-50'>
                            <input type="text" id="txtStepfather_Age" name="txtStepfather_Age" className='add-only' /></td>
                        <td className='w-150'>
                            <input type="checkbox" id="cbStepfather_Living" name="cbStepfather_Living" value="Living" className='add-only' />Living
                            <br />
                            <input type="checkbox" id="cbStepfather_Deceased" name="cbStepfather_Deceased" value="Deceased" className='add-only' />Deceased
                        </td>
                        <td className='w-100'>
                            <input type="text" id="txtStepfather_Relationship" name="txtStepfather_Relationship" className='add-only' /></td>
                        <td className='w-200'>
                            <input type="checkbox" id="cbStepfather_Fulltime" name="cbStepfather_Fulltime" value="Lives with Fulltime" className='add-only' />Lives with Fulltime
                            <br />
                            <input type="checkbox" id="cbStepfather_Halftime" name="cbStepfather_Halftime" value="Lives with part-time" className='add-only' />Lives with part-time
                            <br />
                            <input type="checkbox" id="cbStepfather_NotLiveWith" name="cbStepfather_NotLiveWith" value="Does not live with" className='add-only' />Does not live with
                        </td>
                    </tr>
                    <tr>
                        <td className='w-100'>Stepmother</td>
                        <td className='w-150'>
                            <input type="text" id="txtStepmother_Name" name="txtStepmother_Name" className='add-only' /></td>
                        <td className='w-50'>
                            <input type="text" id="txtStepmother_Age" name="txtStepmother_Age" className='add-only' /></td>
                        <td className='w-150'>
                            <input type="checkbox" id="cbStepmother_Living" name="cbStepmother_Living" value="Living" className='add-only' />Living
                            <br />
                            <input type="checkbox" id="cbStepmother_Deceased" name="cbStepmother_Deceased" value="Deceased" className='add-only' />Deceased
                        </td>
                        <td className='w-100'>
                            <input type="text" id="txtStepmother_Relationship" name="txtStepmother_Relationship" className='add-only' /></td>
                        <td className='w-200'>
                            <input type="checkbox" id="cbStepmother_Fulltime" name="cbStepmother_Fulltime" value="Lives with Fulltime" className='add-only' />Lives with Fulltime
                            <br />
                            <input type="checkbox" id="cbStepmother_Halftime" name="cbStepmother_Halftime" value="Lives with part-time" className='add-only' />Lives with part-time
                            <br />
                            <input type="checkbox" id="cbStepmother_NotLiveWith" name="cbStepmother_NotLiveWith" value="Does not live with" className='add-only' />Does not live with
                        </td>
                    </tr>
                    <tr>
                        <td className='w-100'>Stepsibling</td>
                        <td className='w-150'>
                            <input type="text" id="txtStepsibling_Name_1" name="txtStepsibling_Name_1" className='add-only' /></td>
                        <td className='w-50'>
                            <input type="text" id="txtStepsibling_Age_1" name="txtStepsibling_Age_1" className='add-only' /></td>
                        <td className='w-150'>
                            <input type="checkbox" id="cbStepsibling_Living_1" name="cbStepsibling_Living_1" value="Living" className='add-only' />Living
                            <br />
                            <input type="checkbox" id="cbStepsibling_Deceased_1" name="cbStepsibling_Deceased_1" value="Deceased" className='add-only' />Deceased
                        </td>
                        <td className='w-100'>
                            <input type="text" id="txtStepsibling_Relationship_1" name="txtStepsibling_Relationship_1" className='add-only' /></td>
                        <td className='w-200'>
                            <input type="checkbox" id="cbStepsibling_Fulltime_1" name="cbStepsibling_Fulltime_1" value="Lives with Fulltime" className='add-only' />Lives with Fulltime
                            <br />
                            <input type="checkbox" id="cbStepsibling_Halftime_1" name="cbStepsibling_Halftime_1" value="Lives with part-time" className='add-only' />Lives with part-time
                            <br />
                            <input type="checkbox" id="cbStepsibling_NotLiveWith_1" name="cbStepsibling_NotLiveWith_1" value="Does not live with" className='add-only' />Does not live with
                        </td>
                    </tr>
                    <tr>
                        <td className='w-100'>Stepsibling</td>
                        <td className='w-150'>
                            <input type="text" id="txtStepsibling_Name_2" name="txtStepsibling_Name_2" className='add-only' /></td>
                        <td className='w-50'>
                            <input type="text" id="txtStepsibling_Age_2" name="txtStepsibling_Age_2" className='add-only' /></td>
                        <td className='w-150'>
                            <input type="checkbox" id="cbStepsibling_Living_2" name="cbStepsibling_Living_2" value="Living" className='add-only' />Living
                            <br />
                            <input type="checkbox" id="cbStepsibling_Deceased_2" name="cbStepsibling_Deceased_2" value="Deceased" className='add-only' />Deceased
                        </td>
                        <td className='w-100'>
                            <input type="text" id="txtStepsibling_Relationship_2" name="txtStepsibling_Relationship_2" className='add-only' /></td>
                        <td className='w-200'>
                            <input type="checkbox" id="cbStepsibling_Fulltime_2" name="cbStepsibling_Fulltime_2" value="Lives with Fulltime" className='add-only' />Lives with Fulltime
                            <br />
                            <input type="checkbox" id="cbStepsibling_Halftime_2" name="cbStepsibling_Halftime_2" value="Lives with part-time" className='add-only' />Lives with part-time
                            <br />
                            <input type="checkbox" id="cbStepsibling_NotLiveWith_2" name="cbStepsibling_NotLiveWith_2" value="Does not live with" className='add-only' />Does not live with
                        </td>
                    </tr>
                    <tr>
                        <td className='w-100'>Other</td>
                        <td className='w-150'>
                            <input type="text" id="txtStepsibling_Name_3" name="txtStepsibling_Name_3" className='add-only' /></td>
                        <td className='w-50'>
                            <input type="text" id="txtStepsibling_Age_3" name="txtStepsibling_Age_3" className='add-only' /></td>
                        <td className='w-150'>
                            <input type="checkbox" id="cbStepsibling_Living_3" name="cbStepsibling_Living_3" value="Living" className='add-only' />Living
                            <br />
                            <input type="checkbox" id="cbStepsibling_Deceased_3" name="cbStepsibling_Deceased_3" value="Deceased" className='add-only' />Deceased
                        </td>
                        <td className='w-100'>
                            <input type="text" id="txtStepsibling_Relationship_3" name="txtStepsibling_Relationship_3" className='add-only' /></td>
                        <td className='w-200'>
                            <input type="checkbox" id="cbStepsibling_Fulltime_3" name="cbStepsibling_Fulltime_3" value="Lives with Fulltime" className='add-only' />Lives with Fulltime
                            <br />
                            <input type="checkbox" id="cbStepsibling_Halftime_3" name="cbStepsibling_Halftime_3" value="Lives with part-time" className='add-only' />Lives with part-time
                            <br />
                            <input type="checkbox" id="cbStepsibling_NotLiveWith_3" name="cbStepsibling_NotLiveWith_3" value="Does not live with" className='add-only' />Does not live with
                        </td>
                    </tr>
                    <tr>
                        <td className='w-100'>Other</td>
                        <td className='w-150'>
                            <input type="text" id="txtOther_Name" name="txtOther_Name" className='add-only' /></td>
                        <td className='w-50'>
                            <input type="text" id="txtOther_Age" name="txtOther_Age" className='add-only' /></td>
                        <td className='w-150'>
                            <input type="checkbox" id="cbOther_Living" name="cbOther_Living" value="Living" className='add-only' />Living
                            <br />
                            <input type="checkbox" id="cbOther_Deceased" name="cbOther_Deceased" value="Deceased" className='add-only' />Deceased
                        </td>
                        <td className='w-100'>
                            <input type="text" id="txtOther_Relationship" name="txtOther_Relationship" className='add-only' /></td>
                        <td className='w-200'>
                            <input type="checkbox" id="cbOther_Fulltime" name="cbOther_Fulltime" value="Lives with Fulltime" className='add-only' />Lives with Fulltime
                            <br />
                            <input type="checkbox" id="cbOther_Halftime" name="cbOther_Halftime" value="Lives with part-time" className='add-only' />Lives with part-time
                            <br />
                            <input type="checkbox" id="cbOther_NotLiveWith" name="cbOther_NotLiveWith" value="Does not live with" className='add-only' />Does not live with
                        </td>
                    </tr>
                </table>
                <h3>XIV.  EDUCATIONAL/EMPLOYMENT STATUS</h3>
                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>a. Educational History:  </span>
                            <span className='small'>(check all that apply)</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="checkbox" id="cbGradSchool" name="cbAttendedGradSchool" value="Yes" className='add-only' />Yes &nbsp;&nbsp;&nbsp; Attended grade school</td>
                        <td className='w-375'>
                            <input type="checkbox" id="cbJuniorHighSchool" name="cbJuniorHighSchool" value="Yes" className='add-only' />Yes &nbsp;&nbsp;&nbsp; Attended junior high school</td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="checkbox" id="cbHighSchool" name="cbHighSchool" value="Yes" className='add-only' />Yes &nbsp;&nbsp;&nbsp; Attended high school</td>
                        <td className='w-375'>
                            <input type="checkbox" id="cbGraduatedHighSchool" name="cbGraduatedHighSchool" value="Yes" className='add-only' />Yes &nbsp;&nbsp;&nbsp; Graduated from high school</td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="checkbox" id="cbGFD" name="cbGFD" value="Yes" className='add-only' />Yes &nbsp;&nbsp;&nbsp; GFD</td>
                        <td className='w-375'>
                            <input type="checkbox" id="cbTradeSchool" name="cbTradeSchool" value="Yes" className='add-only' />Yes &nbsp;&nbsp;&nbsp; Attended trade school</td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="checkbox" id="cbGraduatedTradeSchool" name="cbGraduatedTradeSchool" value="Yes" className='add-only' />Yes &nbsp;&nbsp;&nbsp; Graduated from trade school</td>
                        <td className='w-375'>
                            <input type="checkbox" id="cbAttendedCollege" name="cbAttendedCollege" value="Yes" className='add-only' />Yes &nbsp;&nbsp;&nbsp; Attended college</td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="checkbox" id="cbGraduatedCollege" name="cbGraduatedCollege" value="Yes" className='add-only' />Yes &nbsp;&nbsp;&nbsp; Graduated from college
                        </td>

                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="checkbox" id="cbOther12" name="cbOther12" value="Yes" className='add-only' />Yes
                            &nbsp;&nbsp;&nbsp;
                            Other:
                            <input type="text" id="txtOther" name="txtOther" className='add-only w-250 custom-add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>b.  Current Educational Placement/Services:</span>
                            <span className='small'>(check all that apply)</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'><span>Current Educational Placement:</span>
                        </td>
                        <td className='w-375'><span>Current Employment Status(if applicable):</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="text" id="txtCurrentGradeEducational" name="txtCurrentGradeEducational" className='add-only' />
                        </td>
                        <td className='w-375'>
                            <input type="text" id="txtCurrentGradeEmployment" name="txtCurrentGradeEmployment" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'><span>If in school,current grade:</span>
                        </td>
                        <td className='w-375'><span>Name of school:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="text" id="txtCurrentGrade" name="txtCurrentGrade" className='add-only' />
                        </td>
                        <td className='w-375'>
                            <input type="text" id="txtSchoolName" name="txtSchoolName" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><span>Estimated Literacy Level:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="text" id="txtLiteractLevel" name="txtLiteractLevel" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="checkbox" id="cbRegularEducation" name="cbRegularEducation" value="Yes" className='add-only' />Yes &nbsp;&nbsp;&nbsp; Regular Education - no supports </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="checkbox" id="cbHighSchoolRegularEducation" name="cbHighSchoolRegularEducation" value="Yes" className='add-only' />Yes &nbsp;&nbsp;&nbsp; High school Regular Education - Supports </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="checkbox" id="cbGEDRegularEducation" name="cbGEDRegularEducation" value="Yes" className='add-only' />Yes &nbsp;&nbsp;&nbsp; GED Program Regular Education - qualified Section 504 </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="checkbox" id="cbTradeRegularEducation" name="cbTradeRegularEducation" value="Yes" className='add-only' />Yes &nbsp;&nbsp;&nbsp; Trade Regular Education - Alternative School </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="checkbox" id="cbCollegeRegularEducation" name="cbCollegeRegularEducation" value="Yes" className='add-only' />Yes &nbsp;&nbsp;&nbsp; College Regular Education - with consult by Spec.Ed. </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="checkbox" id="cbOtherRegularEducation" name="cbOtherRegularEducation" value="Yes" className='add-only' />Yes &nbsp;&nbsp;&nbsp; Other Regular Education - with direct Spec Ed services </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="checkbox" id="cbSchoolSpecEd" name="cbSchoolSpecEd" value="Yes" className='add-only' />Yes &nbsp;&nbsp;&nbsp; Regular Education - Alt School Spec Ed </td>
                        <td className='w-375'>
                            <input type="checkbox" id="cbRegularEducationResource" name="cbRegularEducationResource" value="Yes" className='add-only' />Yes &nbsp;&nbsp;&nbsp; Regular Education - Resource</td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="checkbox" id="cbSpecialEducation" name="cbSpecialEducation" value="Yes" className='add-only' />Yes &nbsp;&nbsp;&nbsp; Self Contained Special Education</td>
                        <td className='w-375'>
                            <input type="checkbox" id="cbSpecialSchool" name="cbSpecialSchool" value="Yes" className='add-only' />Yes &nbsp;&nbsp;&nbsp; Special School Non Resident</td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="checkbox" id="cbHomeBound" name="cbHomeBound" value="Yes" className='add-only' />Yes &nbsp;&nbsp;&nbsp; Home Bound</td>
                        <td className='w-375'>
                            <input type="checkbox" id="cbResidentialSchool" name="cbResidentialSchool" value="Yes" className='add-only' />Yes &nbsp;&nbsp;&nbsp; Residential School</td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="checkbox" id="cbSchoolProgram" name="cbSchoolProgram" value="Yes" className='add-only' />Yes &nbsp;&nbsp;&nbsp; Psych Hospital School Program</td>
                        <td className='w-375'>
                            <input type="checkbox" id="cbSchoolFacility" name="cbSchoolFacility" value="Yes" className='add-only' />Yes &nbsp;&nbsp;&nbsp; Youth Correctional School Facility</td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="checkbox" id="cbDropOut" name="cbDropOut" value="Yes" className='add-only' />Yes &nbsp;&nbsp;&nbsp; Out of School - Drop Out</td>
                        <td className='w-375'>
                            <input type="checkbox" id="cbExpelled" name="cbExpelled" value="Yes" className='add-only' />Yes &nbsp;&nbsp;&nbsp; Out of School - Expelled</td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="checkbox" id="cbTruant" name="cbTruant" value="Yes" className='add-only' />Yes &nbsp;&nbsp;&nbsp; Out of School -Truant</td>
                        <td className='w-375'>
                            <input type="checkbox" id="cbNotInSchool" name="cbNotInSchool" value="Yes" className='add-only' />Yes &nbsp;&nbsp;&nbsp; Not Yet In School </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>c.  History of Special Education needs:</span>
                            <span className='small'>(check all that apply)</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="checkbox" id="cbClassroom" name="cbClassroom" value="Yes" className='add-only' />Yes &nbsp;&nbsp;&nbsp; Self Contained Classroom</td>
                        <td className='w-375'>
                            <input type="checkbox" id="cbDisabilityAllSubject" name="cbDisabilityAllSubject" value="Yes" className='add-only' />Yes &nbsp;&nbsp;&nbsp; Learning disabilities in all subjects </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="checkbox" id="cbBehavlorProblems" name="cbBehavlorProblems" value="Yes" className='add-only' />Yes &nbsp;&nbsp;&nbsp; Behavlor Problems</td>
                        <td className='w-375'>
                            <input type="checkbox" id="cbPhysicalActivities" name="cbPhysicalActivities" value="Yes" className='add-only' />Yes &nbsp;&nbsp;&nbsp; Challenges in physical activities</td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="checkbox" id="cbRoomPlacement" name="cbRoomPlacement" value="Yes" className='add-only' />Yes &nbsp;&nbsp;&nbsp; Resource room placement</td>
                        <td className='w-375'>
                            <input type="checkbox" id="cbMainstreamed" name="cbMainstreamed" value="Yes" className='add-only' />Yes &nbsp;&nbsp;&nbsp; Mainstreamed with aide</td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="checkbox" id="cbTalented" name="cbTalented" value="Yes" className='add-only' />Yes &nbsp;&nbsp;&nbsp; Gifted and talented</td>
                        <td className='w-375'>
                            <input type="checkbox" id="cbDisabilityInReading" name="cbDisabilityInReading" value="Yes" className='add-only' />Yes &nbsp;&nbsp;&nbsp; Learning disability in reading</td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="checkbox" id="cbDisabilityInMath" name="cbDisabilityInMath" value="Yes" className='add-only' />Yes &nbsp;&nbsp;&nbsp; Learning disabilities in Math</td>
                        <td className='w-375'>
                            <input type="checkbox" id="cbDisabilityInOther" name="cbDisabilityInOther" value="Yes" className='add-only' />Yes &nbsp;&nbsp;&nbsp; Learning disabilities in Other</td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="checkbox" id="cbChallengesInSpeech" name="cbChallengesInSpeech" value="Yes" className='add-only' />Yes &nbsp;&nbsp;&nbsp; Challenges in speech</td>
                        <td className='w-375'>
                            <input type="checkbox" id="cbChallengesInHearing" name="cbChallengesInHearing" value="Yes" className='add-only' />Yes &nbsp;&nbsp;&nbsp; Challenges in hearing</td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="checkbox" id="cbChallengesInSight" name="cbChallengesInSight" value="Yes" className='add-only' />Yes &nbsp;&nbsp;&nbsp; Challenges in sight</td>
                        <td className='w-375'>
                            <input type="checkbox" id="cbOtherEducationNeeds" name="cbOtherEducationNeeds" value="Yes" className='add-only' />Yes &nbsp;&nbsp;&nbsp; Other
                            <input type="text" id="txtOtherEducationNeeds" name="txtOtherEducationNeeds" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>d.  School Behavlors:</span>
                            <span className='small'>(check all that apply)</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="checkbox" id="cbInSchoolSuspension" name="cbInSchoolSuspension" value="Yes" className='add-only' />Yes &nbsp;&nbsp;&nbsp; In school suspension </td>
                        <td className='w-375'>
                            <input type="checkbox" id="cbOutSchoolSuspension" name="cbOutSchoolSuspension" value="Yes" className='add-only' />Yes &nbsp;&nbsp;&nbsp; Out of school suspension </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="checkbox" id="cbInSchoolExpulsion" name="cbInSchoolExpulsion" value="Yes" className='add-only' />Yes &nbsp;&nbsp;&nbsp; School Expulsion</td>
                        <td className='w-375'>
                            <input type="checkbox" id="cbTruancy" name="cbTruancy" value="Yes" className='add-only' />Yes &nbsp;&nbsp;&nbsp; Truancy </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="checkbox" id="cbAbsenteeism" name="cbAbsenteeism" value="Yes" className='add-only' />Yes &nbsp;&nbsp;&nbsp; Absenteeism</td>
                        <td className='w-375'>
                            <input type="checkbox" id="cbFighting" name="cbFighting" value="Yes" className='add-only' />Yes &nbsp;&nbsp;&nbsp; Fighting </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="checkbox" id="cbDestructionProperty" name="cbDestructionProperty" value="Yes" className='add-only' />Yes &nbsp;&nbsp;&nbsp; Destruction of property</td>
                        <td className='w-375'>
                            <input type="checkbox" id="cbCarryingWeapon" name="cbCarryingWeapon" value="Yes" className='add-only' />Yes &nbsp;&nbsp;&nbsp; Carrying Weapon </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="checkbox" id="cbCheating" name="cbCheating" value="Yes" className='add-only' />Yes &nbsp;&nbsp;&nbsp; Cheating </td>
                        <td className='w-375'>
                            <input type="checkbox" id="cbAcademicFallure" name="cbAcademicFallure" value="Yes" className='add-only' />Yes &nbsp;&nbsp;&nbsp; Academic Failure </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="checkbox" id="cbCarryingContraband" name="cbCarryingContraband" value="Yes" className='add-only' />Yes &nbsp;&nbsp;&nbsp; Carrying contraband </td>
                        <td className='w-375'>
                            <input type="checkbox" id="cbSchoolSports" name="cbSchoolSports" value="Yes" className='add-only' />Yes &nbsp;&nbsp;&nbsp; Participating in school sports </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="checkbox" id="cbExtraActivities" name="cbExtraActivities" value="Yes" className='add-only' />Yes &nbsp;&nbsp;&nbsp; Participating in extra-carricular activities </td>
                        <td className='w-375'>
                            <input type="checkbox" id="cbWithTeacher" name="cbWithTeacher" value="Yes" className='add-only' />Yes &nbsp;&nbsp;&nbsp; Got along with teacher </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="checkbox" id="cbOtherSchoolBehavlor_1" name="cbOtherSchoolBehavlor_1" value="Yes" className='add-only' />Yes &nbsp;&nbsp;&nbsp; Other
                            <input type="text" id="txtOtherSchoolBehavlor_1" name="txtOtherSchoolBehavlor_1" className='add-only' />
                        </td>
                        <td className='w-375'>
                            <input type="checkbox" id="cbOtherSchoolBehavlor_2" name="cbOtherSchoolBehavlor_2" value="Yes" className='add-only' />Yes &nbsp;&nbsp;&nbsp; Other
                            <input type="text" id="txtOtherSchoolBehavlor_2" name="txtOtherSchoolBehavlor_2" className='add-only' />
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>e. Learning Needs:</span>
                    <textarea id="txtLearningNeeds" name="txtLearningNeeds" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>f.  Education Related Standardized Test Scores:</span>
                    <span className='small'> Please Enter Scores and Significant findings below</span>
                </p>
                <table>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Education Related Standardized Test</span>
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Date Taken</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="text" id="txtStandardizedTest" name="txtStandardizedTest" className='add-only' />
                        </td>
                        <td className='w-375'>
                            <input type="date" id="txtDateTaken" name="txtDateTaken" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="text" id="txtStandardizedTest1" name="txtStandardizedTest1" className='add-only' />
                        </td>
                        <td className='w-375'>
                            <input type="date" id="txtDateTaken1" name="txtDateTaken1" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Scores/Significant Findings</span>
                        </td>
                        <td className='w-375'>&nbsp;</td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="text" id="txtSignificantFindings" name="txtSignificantFindings" className='add-only' />
                        </td>
                        <td className='w-375'>&nbsp;</td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="text" id="txtSignificantFindings1" name="txtSignificantFindings1" className='add-only' />
                        </td>
                        <td className='w-375'>&nbsp;</td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>g.  IEP/Other Evaluation Dates:</span>
                            <h5>&nbsp;&nbsp; Please complete below:</h5>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'><span className='eleHeader'>IEP Evaluation</span></td>
                        <td className='w-250'><span className='eleHeader'>Date Last Completed</span></td>
                        <td className='w-250'><span className='eleHeader'>Comments</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'>IEP</td>
                        <td className='w-250'>
                            <input type="date" id="txtLastDate1" name="txtLastDate1" className='add-only' /></td>
                        <td className='w-250'>
                            <input type="text" id="txtComments1" name="txtComments1" className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-250'>Special Education Evaluation</td>
                        <td className='w-250'>
                            <input type="date" id="txtLastDate2" name="txtLastDate2" className='add-only' /></td>
                        <td className='w-250'>
                            <input type="text" id="txtComments2" name="txtComments2" className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-250'>Other:<input type="text" id="txtIEPEvaluation1" name="txtIEPEvaluation1" className='add-only' /></td>
                        <td className='w-250'>
                            <input type="date" id="txtLastDate3" name="txtLastDate3" className='add-only' /></td>
                        <td className='w-250'>
                            <input type="text" id="txtComments3" name="txtComments3" className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-250'>Other:<input type="text" id="txtIEPEvaluation2" name="txtIEPEvaluation2" className='add-only' /></td>
                        <td className='w-250'>
                            <input type="date" id="txtLastDate4" name="txtLastDate4" className='add-only' /></td>
                        <td className='w-250'>
                            <input type="text" id="txtComments4" name="txtComments4" className='add-only' /></td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>h.  Recipient's Perception of Education Experience:</span>
                            <span className='small'>(check all that apply)</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="checkbox" id="cbLikedSchool" name="cbLikedSchool" value="Yes" className='add-only' />Yes &nbsp;&nbsp; Likes/liked school </td>
                        <td className='w-375'>
                            <input type="checkbox" id="cbInCrowd" name="cbInCrowd" value="Yes" className='add-only' />Yes &nbsp;&nbsp; Feels/felt like a part of the 'in crowd' </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="checkbox" id="cbFeelsOutsider" name="cbFeelsOutsider" value="Yes" className='add-only' />Yes &nbsp;&nbsp; Feels/felt like a outsider </td>
                        <td className='w-375'>
                            <input type="checkbox" id="cbUnsuccessfullInSchool" name="cbUnsuccessfullInSchool" value="Yes" className='add-only' />Yes &nbsp;&nbsp; Feels/felt unsuccessful in school </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="checkbox" id="cbSuccessfullInSchool" name="cbSuccessfullInSchool" value="Yes" className='add-only' />Yes &nbsp;&nbsp; Feels/felt successful in school </td>
                        <td className='w-375'>
                            <input type="checkbox" id="cbEducationStatus" name="cbEducationStatus" value="Yes" className='add-only' />Yes &nbsp;&nbsp; Was/is satisfied with current educational status </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="checkbox" id="cbEducationExperienceOther_1" name="cbEducationExperienceOther_1" value="Yes" className='add-only' />Yes &nbsp;&nbsp; Other:
                            <input type="text" id="txtEducationExperienceOther_1" name="txtEducationExperienceOther_1" className='add-only' /><br />
                        </td>
                        <td className='w-375'>
                            <input type="checkbox" id="cbEducationExperienceOther_2" name="cbEducationExperienceOther_2" value="Yes" className='add-only' />Yes &nbsp;&nbsp; Others:
                            <input type="text" id="txtEducationExperienceOther_2" name="txtEducationExperienceOther_2" className='add-only' /><br />
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    i. Summarize educational history and status:
                    <textarea id="txtHistorySummarize" name="txtHistorySummarize" className='add-only'></textarea>
                </p>
                <h2>XV. SOCIAL HISTORY AND COMMUNITY INTEGRATION</h2>
                <p className='w-750'>
                    <span className='eleHeader'>a. Current status and functioning</span>
                    <span className='small'>(Involvement in the community, social supports and activities, social barriers)</span>
                    <textarea id="txtHistoryCommunity" name="txtHistoryCommunity" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Does Client/Member feel supported by friends or family?</span>
                    <input type="radio" id="rbClientfeelsupported_Yes" name="rbClientfeelsupported" className='add-only' value="Yes" />
                    Yes
                    <input type="radio" id="rbClientfeelsupported_No" name="rbClientfeelsupported" className='add-only' value="No" />
                    No
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Recreational Activities:</span>
                    <textarea id="txtRecreationalActivities" name="txtRecreationalActivities" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Self-Help Activities:</span>
                    <textarea id="txtSelfHelpActivities" name="txtSelfHelpActivities" className='add-only'></textarea>
                </p>
                <h2>CURRENT STATUS</h2>
                <h3>XVI. MENTAL STATUS EXAMINATION
                    <span className='small'>(Circle or Check all that apply.)</span>
                </h3>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>a. GENERAL APPEARANCE</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbGA_1" name="cbGA_1" className='add-only' value="Healthy" />
                            Healthy;
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbGA_2" name="cbGA_2" className='add-only' value="As stated Age" />
                            As stated Age;
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbGA_3" name="cbGA_3" className='add-only' value="Older Than Stated Age" />
                            Older Than Stated Age;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbGA_4" name="cbGA_4" className='add-only' value="Young-looking" />
                            Young-looking;
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbGA_5" name="cbGA_5" className='add-only' value="Tattoos" />
                            Tattoos;
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbGA_6" name="cbGA_6" className='add-only' value="Disheveled" />
                            Disheveled;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbGA_7" name="cbGA_7" className='add-only' value="Unkempt" />
                            Unkempt;
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbGA_8" name="cbGA_8" className='add-only' value="Malodorous" />
                            Malodorous;
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbGA_9" name="cbGA_9" className='add-only' value="Thin" />
                            Thin;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbGA_10" name="cbGA_10" className='add-only' value="Overweight" />
                            Overweight;
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbGA_11" name="cbGA_11" className='add-only' value="Obese" />
                            Obese;
                        </td>
                        <td className='w-250'></td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="checkbox" id="cbGA_12" name="cbGA_12" className='add-only' value="Other/Describe" />
                            Other/Describe:
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <textarea id="txtGA" name="txtGA" className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>b. BEHAVIOR & PSYCHOMOTOR ACTIVITY</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbPsychomotorActivity_1" name="cbPsychomotorActivity_1" className='add-only' value="Normal" />
                            Normal;
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbPsychomotorActivity_2" name="cbPsychomotorActivity_2" className='add-only' value="Overactive" />
                            Overactive;
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbPsychomotorActivity_3" name="cbPsychomotorActivity_3" className='add-only' value="Hypoactive" />
                            Hypoactive;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbPsychomotorActivity_4" name="cbPsychomotorActivity_4" className='add-only' value="Catatonia" />
                            Catatonia;
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbPsychomotorActivity_5" name="cbPsychomotorActivity_5" className='add-only' value="Tremor" />
                            Tremor;
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbPsychomotorActivity_6" name="cbPsychomotorActivity_6" className='add-only' value="Tics" />
                            Tics;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbPsychomotorActivity_7" name="cbPsychomotorActivity_7" className='add-only' value="Combative" />
                            Combative;
                        </td>
                        <td className='w-250'></td>
                        <td className='w-250'></td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="checkbox" id="cbPsychomotorActivity_9" name="cbPsychomotorActivity_9" className='add-only' value="Other/Describe" />
                            Other/Describe:
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <textarea id="txtPsychomotorActivity" name="txtPsychomotorActivity" className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>c. ATTITUDE</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbAttitude_1" name="cbAttitude_1" className='add-only' value="Optimal" />
                            Optimal;
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbAttitude_2" name="cbAttitude_2" className='add-only' value="Constructive" />
                            Constructive;
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbAttitude_3" name="cbAttitude_3" className='add-only' value="Motivated" />
                            Motivated;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbAttitude_4" name="cbAttitude_4" className='add-only' value="Obstructive" />
                            Obstructive;
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbAttitude_5" name="cbAttitude_5" className='add-only' value="Adversarial" />
                            Adversarial;
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbAttitude_6" name="cbAttitude_6" className='add-only' value="Inaccessible" />
                            Inaccessible;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbAttitude_7" name="cbAttitude_7" className='add-only' value="Cooperative" />
                            Cooperative;
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbAttitude_8" name="cbAttitude_8" className='add-only' value="Seductive" />
                            Seductive;
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbAttitude_9" name="cbAttitude_9" className='add-only' value="Defensive" />
                            Defensive;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbAttitude_10" name="cbAttitude_10" className='add-only' value="Hostile" />
                            Hostile;
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbAttitude_11" name="cbAttitude_11" className='add-only' value="Guarded" />
                            Guarded;
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbAttitude_12" name="cbAttitude_12" className='add-only' value="Apathetic" />
                            Apathetic;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbAttitude_13" name="cbAttitude_13" className='add-only' value="Evasive" />
                            Evasive;
                        </td>
                        <td className='w-250'></td>
                        <td className='w-250'></td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="checkbox" id="cbAttitude_14" name="cbAttitude_14" className='add-only' value="Other/Explain" />
                            Other/Explain:
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <textarea id="txtAttitude" name="txtAttitude" className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>d. SPEECH</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbSpeech_1" name="cbSpeech_1" className='add-only' value="Normal" />
                            Normal;
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbSpeech_2" name="cbSpeech_2" className='add-only' value="Spontaneous" />
                            Spontaneous;
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbSpeech_3" name="cbSpeech_3" className='add-only' value="Slow" />
                            Slow;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbSpeech_4" name="cbSpeech_4" className='add-only' value="Impoverished" />
                            Impoverished;
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbSpeech_5" name="cbSpeech_5" className='add-only' value="Hesitant" />
                            Hesitant;
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbSpeech_6" name="cbSpeech_6" className='add-only' value="Monotonous" />
                            Monotonous;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbSpeech_7" name="cbSpeech_7" className='add-only' value="Soft/Whispered" />
                            Soft/Whispered;
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbSpeech_8" name="cbSpeech_8" className='add-only' value="Mumbled" />
                            Mumbled;
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbSpeech_9" name="cbSpeech_9" className='add-only' value="Rapid" />
                            Rapid;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbSpeech_10" name="cbSpeech_10" className='add-only' value="Pressured" />
                            Pressured;
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbSpeech_11" name="cbSpeech_11" className='add-only' value="Verbose" />
                            Verbose;
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbSpeech_12" name="cbSpeech_12" className='add-only' value="Loud" />
                            Loud;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbSpeech_13" name="cbSpeech_13" className='add-only' value="Slurred" />
                            Slurred;
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbSpeech_14" name="cbSpeech_14" className='add-only' value="Impediment" />
                            Impediment;
                        </td>
                        <td className='w-250'></td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="checkbox" id="cbSpeech_15" name="cbSpeech_15" className='add-only' value="Other/Describe" />
                            Other/Describe:
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <textarea id="txtSpeech" name="txtSpeech" className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>e. MOOD:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbMood_1" name="cbMood_1" className='add-only' value="Dysphoric" />
                            Dysphoric;
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbMood_2" name="cbMood_2" className='add-only' value="Euthymic" />
                            Euthymic;
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbMood_3" name="cbMood_3" className='add-only' value="Expansive" />
                            Expansive;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbMood_4" name="cbMood_4" className='add-only' value="Irritable" />
                            Irritable;
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbMood_5" name="cbMood_5" className='add-only' value="Labile" />
                            Labile;
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbMood_6" name="cbMood_6" className='add-only' value="Elevated" />
                            Elevated;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbMood_7" name="cbMood_7" className='add-only' value="Euphoric" />
                            Euphoric;
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbMood_8" name="cbMood_8" className='add-only' value="Ecstatic" />
                            Ecstatic;
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbMood_9" name="cbMood_9" className='add-only' value="Depressed" />
                            Depressed;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbMood_10" name="cbMood_10" className='add-only' value="Grief/mourning" />
                            Grief/mourning;
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbMood_11" name="cbMood_11" className='add-only' value="Alexithymic" />
                            Alexithymic;
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbMood_12" name="cbMood_12" className='add-only' value="Elated" />
                            Elated;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbMood_13" name="cbMood_13" className='add-only' value="Hypomanic" />
                            Hypomanic;
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbMood_14" name="cbMood_14" className='add-only' value="Manic" />
                            Manic;
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbMood_15" name="cbMood_15" className='add-only' value="Anxious" />
                            Anxious;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbMood_16" name="cbMood_16" className='add-only' value="Tense" />
                            Tense;
                        </td>
                        <td className='w-250'></td>
                        <td className='w-250'></td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="checkbox" id="cbMood_17" name="cbMood_17" className='add-only' value="Other/Describe" />
                            Other/Describe:
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <textarea id="txtMood" name="txtMood" className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>f. AFFECT</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbAffect_1" name="cbAffect_1" className='add-only' value="Appropriate" />
                            Appropriate;
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbAffect_2" name="cbAffect_2" className='add-only' value="Inappropriate" />
                            Inappropriate;
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbAffect_3" name="cbAffect_3" className='add-only' value="Blunted" />
                            Blunted;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbAffect_4" name="cbAffect_4" className='add-only' value="Restricted" />
                            Restricted;
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbAffect_5" name="cbAffect_5" className='add-only' value="Flat" />
                            Flat;
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbAffect_6" name="cbAffect_6" className='add-only' value="Labile" />
                            Labile;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbAffect_7" name="cbAffect_7" className='add-only' value="Tearful" />
                            Tearful;
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbAffect_8" name="cbAffect_8" className='add-only' value="Intense" />
                            Intense;
                        </td>
                        <td className='w-250'></td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="checkbox" id="cbAffect_9" name="cbAffect_9" className='add-only' value="Other/Describe" />
                            Other/Describe:
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <textarea id="txtAffect" name="txtAffect" className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>g. PERCEPTUAL DISTURBANCES</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbPerceptualDisturbances_1" name="cbPerceptualDisturbances_1" className='add-only' value="None" />
                            None;
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbPerceptualDisturbances_111" name="cbPerceptualDisturbances_111" className='add-only' value="None" />
                            Hallucinations:
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbPerceptualDisturbances_5" name="cbPerceptualDisturbances_5" className='add-only' value=" Tactile" />
                            Tactile;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbPerceptualDisturbances_2" name="cbPerceptualDisturbances_2" className='add-only' value="Auditory" />
                            Auditory;
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbPerceptualDisturbances_3" name="cbPerceptualDisturbances_3" className='add-only' value="Visual" />
                            Visual;
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbPerceptualDisturbances_4" name="cbPerceptualDisturbances_4" className='add-only' value="Olfactory" />
                            Olfactory;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="checkbox" id="cbPerceptualDisturbances_6" name="cbPerceptualDisturbances_6" className='add-only' value="Other/Describe" />
                            Other/Describe:
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <textarea id="txtPerceptualDisturbances" name="txtPerceptualDisturbances" className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>h. THOUGHT PROCESS</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbThoughtProcess_1" name="cbThoughtProcess_1" className='add-only' value="Logical/Coherent" />
                            Logical/Coherent;
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbThoughtProcess_2" name="cbThoughtProcess_2" className='add-only' value="Incomprehensible" />
                            Incomprehensible;
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbThoughtProcess_3" name="cbThoughtProcess_3" className='add-only' value="Incoherent" />
                            Incoherent;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbThoughtProcess_4" name="cbThoughtProcess_4" className='add-only' value="Flight of Ideas" />
                            Flight of Ideas;
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbThoughtProcess_5" name="cbThoughtProcess_5" className='add-only' value="LooseAssociations" />
                            Loose Associations;
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbThoughtProcess_6" name="cbThoughtProcess_6" className='add-only' value="Tangential" />
                            Tangential;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbThoughtProcess_7" name="cbThoughtProcess_7" className='add-only' value="Circumstantial" />
                            Circumstantial;
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbThoughtProcess_8" name="cbThoughtProcess_8" className='add-only' value="Rambling" />
                            Rambling;
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbThoughtProcess_9" name="cbThoughtProcess_9" className='add-only' value="Evasive" />
                            Evasive;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbThoughtProcess_10" name="cbThoughtProcess_10" className='add-only' value="Racing Thoughts" />
                            Racing Thoughts;
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbThoughtProcess_11" name="cbThoughtProcess_11" className='add-only' value="Perseveration" />
                            Perseveration;
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbThoughtProcess_12" name="cbThoughtProcess_12" className='add-only' value="Thought Blocking" />
                            Thought Blocking;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbThoughtProcess_13" name="cbThoughtProcess_13" className='add-only' value="Concrete" />
                            Concrete;
                        </td>
                        <td className='w-250'></td>
                        <td className='w-250'></td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="checkbox" id="cbThoughtProcess_14" name="cbThoughtProcess_14" className='add-only' value="Other/Describe" />
                            Other/Describe:
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <textarea id="txtThoughtProcess" name="txtThoughtProcess" className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>i. THOUGHT CONTENT</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbThoughtContent_1" name="cbThoughtContent_1" className='add-only' value="Preoccupations" />
                            Preoccupations;
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbThoughtContent_2" name="cbThoughtContent_2" className='add-only' value="Obsessions" />
                            Obsessions;
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbThoughtContent_3" name="cbThoughtContent_3" className='add-only' value="Compulsions" />
                            Compulsions;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbThoughtContent_4" name="cbThoughtContent_4" className='add-only' value="Phobias" />
                            Phobias;
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbThoughtContent_5" name="cbThoughtContent_5" className='add-only' value="Delusions" />
                            Delusions;
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbThoughtContent_6" name="cbThoughtContent_6" className='add-only' value=" ThoughtBroadcasting" />
                            Thought Broadcasting;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbThoughtContent_7" name="cbThoughtContent_7" className='add-only' value="Thought Insertion" />
                            Thought Insertion;
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbThoughtContent_8" name="cbThoughtContent_8" className='add-only' value="Thought Withdrawal" />
                            Thought Withdrawal;
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbThoughtContent_9" name="cbThoughtContent_9" className='add-only' value="IdeasOfReference" />
                            Ideas of Reference;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbThoughtContent_10" name="cbThoughtContent_10" className='add-only' value="Ideas of Influence" />
                            Ideas of Influence;
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbThoughtContent_11" name="cbThoughtContent_11" className='add-only' value="Delusions" />
                            Delusions;
                        </td>
                        <td className='w-250'></td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="checkbox" id="cbThoughtContent_12" name="cbThoughtContent_12" className='add-only' value="Other/Describe" />
                            Other/Describe:
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <textarea id="txtThoughtContent" name="txtThoughtContent" className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>j. SUICIDAL/ HOMICIDAL IDEATION</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbSHIdeation_1" name="cbSHIdeation_1" className='add-only' value="Suicidal Thoughts" />
                            Suicidal Thoughts;
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbSHIdeation_2" name="cbSHIdeation_2" className='add-only' value="Suicidal Attempts" />
                            Suicidal Attempts;
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbSHIdeation_3" name="cbSHIdeation_3" className='add-only' value="Suicidal Intent" />
                            Suicidal Intent;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbSHIdeation_4" name="cbSHIdeation_4" className='add-only' value="Suicidal Plans" />
                            Suicidal Plans;
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbSHIdeation_5" name="cbSHIdeation_5" className='add-only' value="History of Self-Injurious Behavior" />
                            History of Self-Injurious Behavior;
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbSHIdeation_6" name="cbSHIdeation_6" className='add-only' value="Homicidal Thoughts" />
                            Homicidal Thoughts;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbSHIdeation_7" name="cbSHIdeation_7" className='add-only' value="Homicidal Attempts" />
                            Homicidal Attempts;
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbSHIdeation_8" name="cbSHIdeation_8" className='add-only' value="Homicidal Intent" />
                            Homicidal Intent;
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbSHIdeation_9" name="cbSHIdeation_9" className='add-only' value=" Homicidal Plans" />
                            Homicidal Plans;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="checkbox" id="cbSHIdeation_10" name="cbSHIdeation_10" className='add-only' value="Other/Describe" />
                            Other/Describe:
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <textarea id="txtSHIdeation" name="txtSHIdeation" className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>k. SENSORIUM/ COGNITION</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbSensorium_1" name="cbSensorium_1" className='add-only' value="Alert" />
                            Alert;
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbSensorium_2" name="cbSensorium_2" className='add-only' value="Lethargic" />
                            Lethargic;
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbSensorium_3" name="cbSensorium_3" className='add-only' value="Somnolent" />
                            Somnolent;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbSensorium_4" name="cbSensorium_4" className='add-only' value="Stuporous" />
                            Stuporous;
                        </td>
                        <td className='w-250'></td>
                        <td className='w-250'></td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Oriented to:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbOrientedTo_1" name="cbOrientedTo_1" className='add-only' value="Person" />
                            Person;
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbOrientedTo_2" name="cbOrientedTo_2" className='add-only' value="Place" />
                            Place;
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbOrientedTo_3" name="cbOrientedTo_3" className='add-only' value="Time" />
                            Time;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbOrientedTo_4" name="cbOrientedTo_4" className='add-only' value="Situation" />
                            Situation;
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbOrientedTo_5" name="cbOrientedTo_5" className='add-only' value="Normal Concentration" />
                            Normal Concentration;
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbOrientedTo_6" name="cbOrientedTo_6" className='add-only' value="Impaired Concentration" />
                            Impaired Concentration;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="checkbox" id="cbOrientedTo_7" name="cbOrientedTo_7" className='add-only' value="Other/Describe" />
                            Other/Describe:
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <textarea id="txtOrientedTo" name="txtOrientedTo" className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>l. MEMORY</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <span>Remote Memory:</span>
                        </td>
                        <td className='w-250'>
                            <input type="radio" id="rbRemoteMemory_1" name="rbRemoteMemory" className='add-only' value="Normal" />
                            Normal;
                        </td>
                        <td className='w-250'>
                            <input type="radio" id="rbRemoteMemory_2" name="rbRemoteMemory" className='add-only' value="Impaired" />
                            Impaired;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <span>Recent Memory:</span>
                        </td>
                        <td className='w-250'>
                            <input type="radio" id="rbRecentMemory_1" name="rbRecentMemory" className='add-only' value="Normal" />
                            Normal;
                        </td>
                        <td className='w-250'>
                            <input type="radio" id="rbRecentMemory_2" name="rbRecentMemory" className='add-only' value="Impaired" />
                            Impaired;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <span>Immediate Recall:</span>
                        </td>
                        <td className='w-250'>
                            <input type="radio" id="rbImmediateRecall_1" name="rbImmediateRecall" className='add-only' value="Normal" />
                            Normal;
                        </td>
                        <td className='w-250'>
                            <input type="radio" id="rbImmediateRecall_2" name="rbImmediateRecall" className='add-only' value="Impaired" />
                            Impaired;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="checkbox" id="cbOtherMemory" name="cbOtherMemory" className='add-only' value="Other/Describe" />
                            Other/Describe:
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <textarea id="txtOtherMemory" name="txtOtherMemory" className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>m. INTELLECTUAL FUNCTIONING</span><span className='small'>(Estimate)</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbIntellectualFunctioning_1" name="cbIntellectualFunctioning_1" className='add-only' value="Above Avg" />
                            Above Avg.;
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbIntellectualFunctioning_2" name="cbIntellectualFunctioning_2" className='add-only' value="Normal/Avg" />
                            Normal/Avg.;
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbIntellectualFunctioning_3" name="cbIntellectualFunctioning_3" className='add-only' value="Borderline" />
                            Borderline;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Mental Retardation:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbIntellectualDisability_1" name="cbIntellectualDisability_1" className='add-only' value="Mild" />
                            Mild;
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbIntellectualDisability_2" name="cbIntellectualDisability_2" className='add-only' value="Moderate" />
                            Moderate;
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbIntellectualDisability_3" name="cbIntellectualDisability_3" className='add-only' value="Severe" />
                            Severe;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="checkbox" id="cbIntellectualDisability_4" name="cbIntellectualDisability_4" className='add-only' value="Other/Describe" />
                            Other/Describe:
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <textarea id="txtIntellectualDisability" name="txtIntellectualDisability" className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>n. JUDGEMENT</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbJudgement_1" name="cbJudgement_1" className='add-only' value="Critical Judgment Intact" />
                            Critical Judgment Intact;
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbJudgement_2" name="cbJudgement_2" className='add-only' value="Impaired Judgment" />
                            Impaired Judgment;
                        </td>
                        <td className='w-250'></td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="checkbox" id="cbJudgement_3" name="cbJudgement_3" className='add-only' value="Other/Describe" />
                            Other/Describe:
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <textarea id="txtJudgement" name="txtJudgement" className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>o. INSIGHT</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbInsight_1" name="cbInsight_1" className='add-only' value="True Emotional Insight" />
                            True Emotional Insight;
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbInsight_2" name="cbInsight_2" className='add-only' value="Intellectual Insight" />
                            Intellectual Insight;
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbInsight_3" name="cbInsight_3" className='add-only' value="Impaired Insight" />
                            Impaired Insight;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbInsight_5" name="cbInsight_5" className='add-only' value="Denial" />
                            Denial;
                        </td>
                        <td className='w-500'>
                            <input type="checkbox" id="cbInsight_4" name="cbInsight_4" className='add-only' value="Some Awareness of Illness/symptoms" />
                            Some Awareness of Illness/symptoms;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="checkbox" id="cbInsight_6" name="cbInsight_6" className='add-only' value="Other/Describe" />
                            Other/Describe:
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <textarea id="txtInsight" name="txtInsight" className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>p. IMPULSE CONTROL</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbImpulseControl_1" name="cbImpulseControl_1" className='add-only' value="Able to Resist Impulses" />
                            Able to Resist Impulses
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbImpulseControl_2" name="cbImpulseControl_2" className='add-only' value="Recent Impulsive Behavior" />
                            Recent Impulsive Behavior
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbImpulseControl_3" name="cbImpulseControl_3" className='add-only' value="Impaired Impulse Control" />
                            Impaired Impulse Control
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbImpulseControl_4" name="cbImpulseControl_4" className='add-only' value="Compulsions" />
                            Compulsions
                        </td>
                        <td className='w-250'></td>
                        <td className='w-250'></td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="checkbox" id="cbImpulseControl_5" name="cbImpulseControl_5" className='add-only' value="Other/Describe" />
                            Other/Describe:
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <textarea id="txtImpulseControl" name="txtImpulseControl" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <h2>XVII. Risk Assessment </h2>
                    <span className='small'>Assess potential risk of harm to self or others, including patterns of risk behavior and/or risk due to personality factors, substance use,
                        criminogenic factors, exposure to elements, exploitation, abuse, neglect, suicidal or homicidal history, self-injury, psychosis, impulsiveness, etc.</span>
                </p>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>a. Risk of Harm to Self:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="checkbox" id="cbRHS_1" name="cbRHS_1" className='add-only' value="Prior Suicide Attempt" />
                            Prior Suicide Attempt;
                        </td>
                        <td className='w-375'>
                            <input type="checkbox" id="cbRHS_2" name="cbRHS_2" className='add-only' value="Stated Plan/Intent" />
                            Stated Plan/Intent;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="checkbox" id="cbRHS_3" name="cbRHS_3" className='add-only' value="Access to means" />
                            Access to means (weapons, pills, etc.);
                        </td>
                        <td className='w-375'>
                            <input type="checkbox" id="cbRHS_4" name="cbRHS_4" className='add-only' value="Recent Loss" />
                            Recent Loss;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="checkbox" id="cbRHS_5" name="cbRHS_5" className='add-only' value="Presence of Behavioral Cues" />
                            Presence of Behavioral Cues (isolation, giving away possessions, rapid mood swings, etc.);
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="checkbox" id="cbRHS_6" name="cbRHS_6" className='add-only' value="Family History of Suicide" />
                            Family History of Suicide;
                        </td>
                        <td className='w-375'>
                            <input type="checkbox" id="cbRHS_7" name="cbRHS_7" className='add-only' value="Terminal Illness" />
                            Terminal Illness;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="checkbox" id="cbRHS_8" name="cbRHS_8" className='add-only' value="Substance Abuse" />
                            Substance Abuse;
                        </td>
                        <td className='w-375'>
                            <input type="checkbox" id="cbRHS_9" name="cbRHS_9" className='add-only' value="Marked lack of support" />
                            Marked lack of support;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="checkbox" id="cbRHS_10" name="cbRHS_10" className='add-only' value="Psychosis" />
                            Psychosis;
                        </td>
                        <td className='w-375'>
                            <input type="checkbox" id="cbRHS_11" name="cbRHS_11" className='add-only' value="Suicide of friend/acquaintance" />
                            Suicide of friend/acquaintance;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="checkbox" id="cbRHS_12" name="cbRHS_12" className='add-only' value="Other/Describe" />
                            Other/Describe:
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <textarea id="txtRHS" name="txtRHS" className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>b. Risk of Harm to Others:</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="checkbox" id="cbRHO_1" name="cbRHO_1" className='add-only' value="Prior Suicide Attempt" />
                            Prior Acts of Violence;
                            <input type='text' id="txtRHO_1" name="txtRHO_1" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="checkbox" id="cbRHO_2" name="cbRHO_2" className='add-only' value="Destruction of property" />
                            Destruction of property;
                        </td>
                        <td className='w-375'>
                            <input type="checkbox" id="cbRHO_3" name="cbRHO_3" className='add-only' value="Arrests for violence" />
                            Arrests for violence;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="checkbox" id="cbRHO_4" name="cbRHO_4" className='add-only' value="Access to means" />
                            Access to means (weapons);
                        </td>
                        <td className='w-375'>
                            <input type="checkbox" id="cbRHO_5" name="cbRHO_5" className='add-only' value="Substance use" />
                            Substance use;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="checkbox" id="cbRHO_6" name="cbRHO_6" className='add-only' value="Physically abused as child" />
                            Physically abused as child;
                        </td>
                        <td className='w-375'>
                            <input type="checkbox" id="cbRHO_7" name="cbRHO_7" className='add-only' value="Was physically abusive as a child" />
                            Was physically abusive as a child;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="checkbox" id="cbRHO_8" name="cbRHO_8" className='add-only' value="Harms animals" />
                            Harms animals;
                        </td>
                        <td className='w-375'>
                            <input type="checkbox" id="cbRHO_9" name="cbRHO_9" className='add-only' value="Fire setting" />
                            Fire setting;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="checkbox" id="cbRHO_10" name="cbRHO_10" className='add-only' value="Angry mood/agitation" />
                            Angry mood/agitation;
                        </td>
                        <td className='w-375'>
                            <input type="checkbox" id="cbRHO_11" name="cbRHO_11" className='add-only' value="Prior hospitalizations for danger to others" />
                            Prior hospitalizations for danger to others;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="checkbox" id="cbRHO_12" name="cbRHO_12" className='add-only' value="Psychosis" />
                            Psychosis/command hallucinations;
                        </td>
                        <td className='w-375'></td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="checkbox" id="cbRHO_13" name="cbRHO_13" className='add-only' value="Other/Describe" />
                            Other/Describe:
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <textarea id="txtRHO" name="txtRHO" className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>c. Client/Member Safety & Other Risk Factors:</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="checkbox" id="cbCSORF_1" name="cbCSORF_1" className='add-only' value="Feels unsafe in current living environment" />
                            Feels unsafe in current living environment;
                        </td>
                        <td className='w-375'>
                            <input type="checkbox" id="cbCSORF_2" name="cbCSORF_2" className='add-only' value="Relapse/decompensation triggers" />
                            Relapse/decompensation triggers;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="checkbox" id="cbCSORF_3" name="cbCSORF_3" className='add-only' value="Feels currently being harmed/hurt/abused/threatened by someone" />
                            Feels currently being harmed/hurt/abused/threatened by someone;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="checkbox" id="cbCSORF_4" name="cbCSORF_4" className='add-only' value="Engages in dangerous sexual behavior" />
                            Engages in dangerous sexual behavior;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="checkbox" id="cbCSORF_5" name="cbCSORF_5" className='add-only' value="Past involvement with Child or Adult Protective Services" />
                            Past involvement with Child or Adult Protective Services;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="checkbox" id="cbCSORF_6" name="cbCSORF_6" className='add-only' value="Other/Describe" />
                            Other/Describe:
                            <input type="text" id="txtCSORF" name="txtCSORF" className='add-only' />
                        </td>
                        <td className='w-375'>
                            <input type="checkbox" id="cbd_1" name="cbd_1" className='add-only' value="Inappropriate sexual behaviors" />
                            Inappropriate sexual behaviors;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="checkbox" id="cbd_2" name="cbd_2" className='add-only' value="Sex offender status" />
                            Sex offender status;
                        </td>
                        <td className='w-375'>
                            <input type="checkbox" id="cbd_3" name="cbd_3" className='add-only' value="Pending sex offense charge" />
                            Pending sex offense charge;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="checkbox" id="cbd_4" name="cbd_4" className='add-only' value="Report or Investigation" />
                            Report or Investigation;
                        </td>
                        <td className='w-375'></td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="checkbox" id="cbd_5" name="cbd_5" className='add-only' value="Other" />
                            Other:
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <textarea id="txtOtherClientSaftey" name="txtOtherClientSaftey" className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>d. </span></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="checkbox" id="cbd1_4" name="cbd1_4" className='add-only' value="lnappropriate sexual behaviors" />
                            lnappropriate sexual behaviors;
                        </td>
                        <td className='w-375'>
                            <input type="checkbox" id="cbd2_4" name="cbd2_4" className='add-only' value="Sexual offender status" />
                            Sexual offender status
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="checkbox" id="cbd3_4" name="cbd3_4" className='add-only' value="Pending sex offense charge" />
                            Pending sex offense charge;
                        </td>
                        <td className='w-375'>
                            <input type="checkbox" id="cbd4_4" name="cbd4_4" className='add-only' value="Report or Investigation" />
                            Report or Investigation
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="checkbox" id="cbd5_5" name="cbd5_5" className='add-only' value="Other" />
                            Other:
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <textarea id="txtOtherClientSafteyOther" name="txtOtherClientSafteyOther" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>e. Additional Risk Factors</span>
                    <textarea id="txtAdditional" name="txtAdditional" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>f. Preferences and Desires</span>
                    <span className='small'>Describe recipient's preferences and desires for addressing risk factors, including any Mental Health Advance Directives or plan of response to periods of decompensation/relapse (Ex. Resources recipient feels comfortable reaching out to for assistance in a crisis.)</span>
                    <textarea id="txtPreferencesAndDesires" name="txtPreferencesAndDesires" className='add-only'></textarea>
                </p>
                <h2>COUNSELING</h2>
                <h3>CULTURAL AND LANGUAGE PREFERENCES
                    <span className='small'>(Language, Customs/Values/Preferences)</span>
                </h3>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>a. Language of Choice:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="text" id="txtSpiritualBeliefsLanguage" name="txtSpiritualBeliefsLanguage" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>b. Spiritual Beliefs/Preferences</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="text" id="txtSpiritualBeliefs" name="txtSpiritualBeliefs" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>c. Cultural Beliefs/Preferences</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="text" id="txtCulturalBeliefs" name="txtCulturalBeliefs" className='add-only' />
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>Is there a need for assistive technology in the provision of services?</span>
                    <input type="radio" id="rbLegalGuardianNeed_Yes" name="rbLegalGuardianNeed" className='add-only' value="Yes" /> Yes &nbsp;
                    <input type="radio" id="rbLegalGuardianNeed_No" name="rbLegalGuardianNeed" className='add-only' value="No" /> No
                </p>
                <p className='w-750'>
                    If yes, explain:
                    <textarea id="txtPreferencesAndDesiresExplain11" name="txtPreferencesAndDesiresExplain11" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>XIX. AVAILABILTY OF SOCIAL SUPPORTS (PARENTS, FAMILY MEMBERS, FRIENDS)</span>
                    <textarea id="txtPreferencesAndDesiresExplain" name="txtPreferencesAndDesiresExplain" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>XX. PRINCIPAL DIAGNOSES</span>
                </p>
                <table>
                    <tr>
                        <td className='w-750'>AXIS I
                            <input type="text" id="txtPrincipalDiagnoses_1" name="txtPrincipalDiagnoses_1" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>AXIS II
                            <input type="text" id="txtPrincipalDiagnoses_2" name="txtPrincipalDiagnoses_2" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>AXIS III
                            <input type="text" id="txtPrincipalDiagnoses_3" name="txtPrincipalDiagnoses_3" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>AXIS IV
                            <input type="text" id="txtPrincipalDiagnoses_4" name="txtPrincipalDiagnoses_4" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>AXIS V
                            <input type="text" id="txtPrincipalDiagnoses_5" name="txtPrincipalDiagnoses_5" className='add-only' />
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Current</span>
                            <input type="text" id="txtCurrent" name="txtCurrent" className='add-only' />
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Highest Past Year</span>
                            <input type="text" id="txtHighestPastYear" name="txtHighestPastYear" className='add-only' />
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>XXI. INTERPRETIVE SUMMARY</span>
                    <span className='small'>Briefly describe client/member's global preferences/hopes for recovery, your clinical summary, and recommended treatments/assessments, level of care, duration.</span>
                    <textarea id="txtInterpretiveSummary" name="txtInterpretiveSummary" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>a. List client's individual strengths. abilities. needs, preferences. attitudes. interests, and skills:</span>
                    <textarea id="txtInterpretiveSummary1" name="txtInterpretiveSummary1" className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>b. Recommended Services:</span>
                            <span className='small'>(Check all that apply.)</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbRC_1" name="cbRC_1" className='add-only' value="Family Therapy" />
                            Family Therapy;
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbRC_2" name="cbRC_2" className='add-only' value="Individual Therapy" />
                            Individual Therapy;
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbRC_3" name="cbRC_3" className='add-only' value="Group Therapy" />
                            Group Therapy;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbRC_4" name="cbRC_4" className='add-only' value="Alcohol/Drug Assessment" />
                            Alcohol/Drug Assessment;
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbRC_5" name="cbRC_5" className='add-only' value="Alcohol/ Drug Individual Therapy" />
                            Alcohol/ Drug Individual Therapy;
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbRC_6" name="cbRC_6" className='add-only' value="PSR" />
                            PSR;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbRC_7" name="cbRC_7" className='add-only' value="CPST" />
                            CPST;
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="Medication_7" name="Medication_7" className='add-only' value="Medication Management" />
                            Medication Management;
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbRCParent_7" name="cbRCParent_7" className='add-only' value="Parent Support" />
                            Parent Support/Training;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbRCYouth_7" name="cbRCYouth_7" className='add-only' value="Youth Support" />
                            Youth Support/Training;
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbRCCrisis_7" name="cbRCCrisis_7" className='add-only' value="Crisis stabilization" />
                            Crisis stabilization;
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbRCRespite_7" name="cbRCRespite_7" className='add-only' value="Respite" />
                            Respite;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-500'>
                            <input type="checkbox" id="cbRCIndependent_7" name="cbRCIndependent_7" className='add-only' value="Independent Living" />
                            Independent Living/Skills Training;
                        </td>
                        <td className='w-250'>&nbsp;</td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="checkbox" id="cbRC_8" name="cbRC_8" className='add-only' value="Other/Describe" />
                            Other/Describe:
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <textarea id="txtRCOtherDescribe" name="txtRCOtherDescribe" className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>c. Other Services/Linkages Needed:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbLinkageNeeds_1" name="cbLinkageNeeds_1" className='add-only' value="Vocational Services" />
                            Vocational Services;
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbLinkageNeeds_2" name="cbLinkageNeeds_2" className='add-only' value="Social Services" />
                            Social Services;
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbLinkageNeeds_3" name="cbLinkageNeeds_3" className='add-only' value="Educational Services" />
                            Educational Services;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbLinkageNeeds_4" name="cbLinkageNeeds_4" className='add-only' value="Medical Services/PCP" />
                            Medical Services/PCP;
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbLinkageNeeds_5" name="cbLinkageNeeds_5" className='add-only' value="Self help Groups" />
                            Self help Groups;
                        </td>
                        <td className='w-250'></td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="checkbox" id="cbLinkageNeeds_6" name="cbLinkageNeeds_6" className='add-only' value="Other/Describe" />
                            Other/Describe:
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <textarea id="txtLinkNeedOther" name="txtLinkNeedOther" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>d. Additional Comments</span>
                    <textarea id="txtAdditionalComments" name="txtAdditionalComments" className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>e. Topics to Assist with creating goals(Choose at least 3):</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbTopics_1" name="cbTopics_1" className='add-only' value="Goal Setting" />
                            Goal Setting
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbTopics2" name="cbTopics2" className='add-only' value="Leisure" />
                            Leisure
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbTopics3" name="cbTopics3" className='add-only' value="Motivation" />
                            Motivation
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbTopics_4" name="cbTopics_4" className='add-only' value="Problem Solving" />
                            Problem Solving
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbTopics5" name="cbTopics5" className='add-only' value="Self Awareness" />
                            Self Awareness
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbTopics6" name="cbTopics6" className='add-only' value="Self-Esteem" />
                            Self-Esteem
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbTopics_7" name="cbTopics_7" className='add-only' value="Stress Management" />
                            Stress Management
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbTopics8" name="cbTopics58" className='add-only' value="Time Management" />
                            Time Management
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbTopics9" name="cbTopics9" className='add-only' value="Anger Management" />
                            Anger Management
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbTopics_10" name="cbTopics_10" className='add-only' value="Communication" />
                            Communication
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbTopics11" name="cbTopics11" className='add-only' value="Coping Skills" />
                            Coping Skills
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbTopics12" name="cbTopics12" className='add-only' value="Grief/Loss" />
                            Grief/Loss
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbTopics_13" name="cbTopics_13" className='add-only' value="Life Balance" />
                            Life Balance
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbTopics14" name="cbTopics14" className='add-only' value="Social Skills" />
                            Social Skills
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbTopics15" name="cbTopics15" className='add-only' value="Daily Living" />
                            Daily Living
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbTopics_16" name="cbTopics_16" className='add-only' value="Interpersonal skills" />
                            Interpersonal skills
                        </td>
                        <td className='w-250'>&nbsp; </td>
                        <td className='w-250'>&nbsp;</td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbTopicsOther_4" name="cbTopicsOther_4" className='add-only' value="Other" />
                            Other:
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <textarea id="txtAdditionalCommentsOther12" name="txtAdditionalCommentsOther12" className='add-only'></textarea></p>
                <h2>Signature</h2>
                <table>
                    <tr>
                        <td className="signature w-187">&nbsp; </td>
                        <td className="signature w-187">&nbsp; </td>
                        <td className="signature w-187">&nbsp; </td>
                        <td className="signature w-187">&nbsp; </td>
                    </tr>
                    <tr>
                        <td className="small w-187">PRINTED NAME OF ASSESSOR
                        </td>
                        <td className="small w-187">SIGNATURE
                        </td>
                        <td className="small w-187">LMHP STATUS
                        </td>
                        <td className="small w-187">DATE
                        </td>
                    </tr>
                </table>
            </div>
        </form>

    )
}











